import { useEffect, useMemo, useState } from "react";
import {
    Box, Button, Icon,
    LinearProgress,
    Paper, Tab,
    Tabs, Typography, useTheme,
    Tooltip, TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Autocomplete,
    CircularProgress,
    Card,
    CardContent

} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { Loading } from "../../shered/components/loading/Loading";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDebounce } from "../../shered/hooks";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from '../../shered/layouts';
import { FerramentasDeDetalhe } from '../../shered/components';
import { DialogMensagem, IDadosModal } from '../../shered/components/modal/DialogMensagem';
import { FranquiaService, IDetalheFranquia, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import { DraftService, IDadosStats, IDetalheDraftPicksTable, IListagemJogador, IListagemTabelaPicks, IDadosSalvarJogadorDraftCalouros, IDadosSalvarJogadorDraftInicial, IDadosSalarioCalouros, IDetalheDraftSorteioPicks, IDadosSorteio, IDadosPorcentagemEscolha } from "../../shered/services/api/draft/DraftService";
import { TDropOptions, TipoSalario, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { IDadosEstatisticas, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { addHours, getDate } from "date-fns";
import { DonwloadSalarios } from "../../shered/components/arquivos/DonwloadSalariosNBA";
import moment from "moment-timezone";
import { getTodayDate } from "@mui/x-date-pickers/internals";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {
                //value === index && (
                <Box sx={{ p: UtilidadeService.isMobile() ? 1 : 3 }}>
                    <Grid>{children}</Grid>
                </Box>
                //)
            }
        </div>
    );
}

const columnsEscolhas: GridColDef[] = [
    {
        field: 'escolha',
        headerName: UtilidadeService.isMobile() ? 'ESC' : 'ESCOLHA',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 50 : 90,
        editable: false,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        sortable: false

    },
    {
        field: 'foto_Franquia',
        headerName: 'LOGO',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 55 : 65,
        editable: false,
        sortable: false,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ?
            <img src={params.value} alt={params.value} width={UtilidadeService.isMobile() ? 25 : 45} height={UtilidadeService.isMobile() ? 30 : 50} />
            : <img src="../../../semimagemescudo.png" alt={params.value} width={UtilidadeService.isMobile() ? 30 : 45} height={UtilidadeService.isMobile() ? 30 : 50} />
    },
    {
        field: 'nome_Franquia',
        headerName: 'FRANQUIA',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 85 : 250,
        editable: false,
        sortable: false,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },

    {
        field: 'foto_Jogador',
        headerName: 'FOTO',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 50 : 65,
        editable: false,
        sortable: false,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ?
            <img src={params.value} alt={params.value} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "../../../../semimagem.png";
                    //currentTarget.style.borderRadius = "25%";
                    currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "50px";
                    currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "50px";
                }}
            />
            : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />,
    },
    {
        field: 'nome_Jogador',
        headerName: 'JOGADOR',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 110 : 250,
        editable: false,
        sortable: false,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },
    {
        field: 'escolha_Atual',
        headerName: 'STATUS',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 85 : 250,
        editable: false,
        sortable: false,
        headerClassName: 'super-app-theme--header'

    }
];

interface IGridColumnHeaderParams {
    pick: "",
    nome_Franquia_Original: "",
    logo_Fraqnuia_Dono: "",
    nome_Franquia_Dono: "",
    restrito: false,
    ano1: string;
    ano2: string;
    ano3: string;
    ano4: string;
    ano5: string;
    ano6: string;
}

export const Drafts: React.FC = () => {
    const theme = useTheme();
    const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [codigoFranquia, setCodigoFranquia] = useState(0);
    const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [existeDadosJogador, setExisteDadosJogador] = useState(false);
    const navigate = useNavigate();
    const { debounce } = useDebounce();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const { logout } = useAuthContext();
    const { themeName } = useAppThemeContext();
    const [codigoTemporadaPicks, setCodigoTemporadaPicks] = useState(0);
    const [codigoTemporadaSalario, setCodigoTemporadaSalario] = useState(0);
    const [codigoFranquiaFiltro, setCodigoFranquiaFiltro] = useState(0);
    const [codigoRodadaFiltro, setCodigoRodadaFiltro] = useState(0);
    const [semImagemFranquia, setSemImagemFranquia] = useState<any>("../../semimagemescudo.png");

    const [isLoading, setIsLoading] = useState(false);
    const [comissario, setComissario] = useState(false);
    const [draftCalourosAberta, setDraftCalourosAberta] = useState(false);
    const [sem_Relogio_Calouro, setSem_Relogio_Calouro] = useState(false);
    const [tempo_Escolha_Calouro, setTempo_Escolha_Calouro] = useState(0);
    const [data_Abertura_Calouro, setData_Abertura_Calouro] = useState<Date>(new Date);
    const [data_Encerramento_Calouro, setData_Encerramento_Calouro] = useState<Date>(new Date);

    const [sem_Relogio_Inicial, setSem_Relogio_Inicial] = useState(false);
    const [tempo_Escolha_Inicial, setTempo_Escolha_Inicial] = useState(0);
    const [data_Abertura_Inicial, setData_Abertura_Inicial] = useState<Date>(new Date);
    const [data_Encerramento_Inicial, setData_Encerramento_Inicial] = useState<Date>(new Date);
    const [periodoFinalInicial, setPeriodoFinalInicial] = useState("");
    const [periodoInicioInicial, setPeriodoInicioInicial] = useState("");

    const [showCalourosEscolha, setShowCalourosEscolha] = useState(false);
    const [draftInicialAberta, setDraftInicialAberta] = useState(false);

    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [nomeLiga, setNomeLiga] = useState("");
    const [showImagemDraft, setShowImagemDraft] = useState<any>("../../Draft2023_2.png");
    const [logoImage, setLogoImage] = useState("");
    const [removeLoading, setRemoveLoading] = useState(false);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [periodoFinal, setPeriodoFinal] = useState("");
    const [periodoInicial, setPeriodoInicial] = useState("");

    const [rowsSalario, setRowsSalario] = useState<IDadosSalarioCalouros[]>([]);

    const [opcoesAutoCompleteJogadorInicial, setOpcoesAutoCompleteJogadorInicial] = useState<TDropOptions[]>([])
    const [opcoesAutoCompleteJogadorCalouros, setOpcoesAutoCompleteJogadorCalouros] = useState<TDropOptions[]>([])
    const [lstFranquias, setLstFranquias] = useState<ILstDrop[]>([])
    const [listaDataGridPorcentagemEscolha, SetListaDataGridPorcentagemEscolha] = useState<IDadosPorcentagemEscolha[]>([])
    const [codigoTemporada, setCodigoTemporada] = useState(0);
    const [selectedIdCompleteInicial, setSelectedIdCompleteInicial] = useState<number | undefined>(0);
    const [selectedIdCompleteCalouros, setSelectedIdCompleteCalouros] = useState<number | undefined>(0);
    const [escolhasInicialRows, setEscolhasInicialRows] = useState<IListagemTabelaPicks[]>([]);
    const [escolhasCalourosRows, setEscolhasCalourosRows] = useState<IListagemTabelaPicks[]>([]);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "success",
        mensagem: "Processo realizado com sucesso!",
        display: "none",
        titulo: "Sucesso"
    });
    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });
    const [value, setValue] = useState(0);
    const [redirecionar, setRedirecionar] = useState("");
    function a11yProps(index: number) {

        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    //#region  dados listagem picks

    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [rowsPicks, setRowsPicks] = useState<IDetalheDraftPicksTable[]>([]);
    const [rowsSorteioPicks, setRowsSorteiosPicks] = useState<IDetalheDraftSorteioPicks[]>([]);
    const [searchParamsPicks, SetSearchParamsPicks] = useSearchParams();
    const paginaPicks = useMemo(() => {
        return Number(searchParamsPicks.get("pagina") || "1");
    }, [searchParamsPicks]);
    const [tempoZerado, setTempoZerado] = useState(false);

    useEffect(() => {
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });

            setRedirecionar("/dashboard");
            return;
        }
        setIsLoading(true);

        const fetchData = async () => {
            setIsLoading(false);
            setRemoveLoading(true);
            UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    let lstTemporadasAux = result.data.dado.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                    setLstTemporadas(lstTemporadasAux);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                });

            await FranquiaService.getByIdLiga(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    let lstFraqnuiasAux = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome }));
                    setLstFranquias(lstFraqnuiasAux);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                });

            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const liga = result.dado;
                    setDadosLiga(liga);
                    setNomeLiga(liga.nome);
                    setDraftCalourosAberta(liga.abertura_Draft === true ? liga.abertura_Draft : liga.sem_Relogio_Calouro);
                    setSem_Relogio_Calouro(liga.sem_Relogio_Calouro);
                    setTempo_Escolha_Calouro(liga.tempo_Escolha_Calouro);
                    setData_Abertura_Calouro(liga.data_Abertura_Calouro);
                    setData_Encerramento_Calouro(liga.data_Encerramento_Calouro);
                    setPeriodoInicial(liga.periodo_Util_Inicial_Calouro);
                    setPeriodoFinal(liga.periodo_Util_Final_Calouro);
                    setCodigoTemporada(liga.codigo_Temporada);
                    setCodigoTemporadaPicks(liga.codigo_Temporada !== undefined ? liga.codigo_Temporada : 0);
                    setCodigoTemporadaSalario(liga.codigo_Temporada !== undefined ? liga.codigo_Temporada : 0);
                    setDraftInicialAberta(liga.abertura_Draft_Inicial === true ? liga.abertura_Draft_Inicial : liga.sem_Relogio_Inicial);
                    setSem_Relogio_Inicial(liga.sem_Relogio_Inicial);
                    setTempo_Escolha_Inicial(liga.tempo_Escolha_Inicial);
                    setData_Abertura_Inicial(liga.data_Abertura_Inicial);
                    setData_Encerramento_Inicial(liga.data_Encerramento_Inicial);
                    setPeriodoInicioInicial(liga.periodo_Util_Inicio_Inicial);
                    setPeriodoFinal(liga.periodo_Util_Final_Inicial);
                    if (liga.caminho_Logo !== null) {
                        setShowImagemDraft(liga.caminho_Logo);
                    }
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                });

            await DraftService.getBuscarPicksDraft(paginaPicks, Number(codigoLiga), 1)
                .then((result) => {
                    setIsLoading(false);
                    const drafts = result.data.dado;
                    const newDrafts = drafts.map((m, i) => ({
                        id: i + 1,
                        codigo: m.codigo,
                        caminho_Logo_Franquia_Dono: m.caminho_Logo_Franquia_Dono,
                        nome_Franquia_Dono: m.nome_Franquia_Dono,
                        caminho_Logo_Franquia_Original: m.caminho_Logo_Franquia_Original,
                        nome_Franquia_Original: m.nome_Franquia_Original,
                        foto_Jogador_Escolhido: m.foto_Jogador_Escolhido,
                        nome_Jogador_Escolhido: m.nome_Jogador_Escolhido,
                        codigo_Franquia_Original: m.codigo_Franquia_Original,
                        codigo_Franquia_Dono: m.codigo_Franquia_Dono,
                        codigo_Temporada: m.codigo_Temporada,
                        rodada: m.rodada,
                        posicao_Final: m.posicao_Final
                    }));
                    setRowsPicks(newDrafts);
                    //formRef.current?.setFieldValue("configuracao_Liga.codigo_Temporada", Number(drafts.pop()?.codigo_Temporada));

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                });
        }
        fetchData();

    }, [paginaPicks, codigoLiga]);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(false);
            setRemoveLoading(true);
            CarregarDadosSorteioCalouros();
            setRemoveLoading(true);
            setIsLoading(false);            
        }
        fetchData();

    }, [tempoZerado]);

    //#endregion

    //#region Dados Escolha 
    const { id } = useParams<"id">();
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [showImagemFranquiaCalouro, setShowImagemFranquiaCalouro] = useState<any>("../../semimagemescudo.png");

    const [searchParamsEscolha, SetSearchParamsEscolha] = useSearchParams();

    const [nome_Franquia, setNome_Franquia] = useState("");
    const [nome_FranquiaCalouro, setNome_FranquiaCalouro] = useState("");
    const [franquia, setFranquia] = useState<IDetalheFranquia>();  
    const [escolhaAtual, setEscolhaAtual] = useState(1);
    const [escolhaAtualCalouros, setEscolhaAtualCalouros] = useState(1);
    const [codigoFranquiaEscolha, setCodigoFranquiaEscolha] = useState(0);
    const [codigoFranquiaEscolhaInicial, setCodigoFranquiaEscolhaInicial] = useState(0);
    const [dataUltimoSorteio, setDataUltimoSorteio] = useState<any>();

    const [minhaVezEscolha, setMinhaVezEscolha] = useState(false);

    const [sorteioRealizado, setSorteioRealizado] = useState(false);
    const [sorteioFinalizado, setSorteioFinalizado] = useState(false);
    const [showBotaoEscolherInicial, setShowBotaoEscolherInicial] = useState(false);
    const [dataFinalEscolha, setDataFinalEscolha] = useState<Date>(new Date());
    const [minhaVezEscolhaCalouros, setMinhaVezEscolhaCalouros] = useState(false);
    const [dataFinalEscolhaCalouros, setDataFinalEscolhaCalouros] = useState<Date>(new Date());
    const [dataLimiteEscolha, setDataLimiteEscolha] = useState("");
    const [dataLimiteEscolhaInicial, setDataLimiteEscolhaInicial] = useState("");
    const [dataLimiteEscolhaCalouro, setDataLimiteEscolhaCalouro] = useState("");


    const [fotoJogador, setFotoJogador] = useState<string>("");
    const [nomeJogador, setNomeJogador] = useState<string>("");
    const [dadosJogador, setDadosJogador] = useState<IDadosEstatisticas>();
    const [lstDadosJogador, setLstDadosJogador] = useState<IDadosEstatisticas[]>([]);
    const [listaDataGridCalouro, setListaDataGridCalouro] = useState<IDadosEstatisticas[]>([]);
    const [franquiaJogador, setFranquiaJogador] = useState<string>("");
    const [salario1, setSalario1] = useState<string>("");
    const [salario2, setSalario2] = useState<string>("");
    const [salario3, setSalario3] = useState<string>("");
    const [salario4, setSalario4] = useState<string>("");
    const [salario5, setSalario5] = useState<string>("");
    const [salario1Calouro, setSalario1Calouro] = useState<string>("");
    const [salario2Calouro, setSalario2Calouro] = useState<string>("");
    const [salario3Calouro, setSalario3Calouro] = useState<string>("");
    const [salario4Calouro, setSalario4Calouro] = useState<string>("");
    const [salario5Calouro, setSalario5Calouro] = useState<string>("");
    const [listaJogadoresInicial, setListaJogadoresInicial] = useState<IDadosEstatisticas>();
    //let valDataFinalEscolha = new Date();

    const [listaStats, setListaStats] = useState<IDadosStats[]>([]);
    const autoCompleteSelectedOptionInicial = useMemo(() => {
        if (!selectedIdCompleteInicial) return null;

        const selectedOption = opcoesAutoCompleteJogadorInicial.find(opcao => opcao.codigo === selectedIdCompleteInicial);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdCompleteInicial, opcoesAutoCompleteJogadorInicial]);

    const autoCompleteSelectedOptionCalouros = useMemo(() => {
        if (!selectedIdCompleteCalouros) return null;

        const selectedOption = opcoesAutoCompleteJogadorCalouros.find(opcao => opcao.codigo === selectedIdCompleteCalouros);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdCompleteCalouros, opcoesAutoCompleteJogadorCalouros]);

    useEffect(() => {
        const fetchData = async () => {
            setRemoveLoading(false);
            setShowModalMensagem(false);
            if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "warning",
                    mensagem: "Favor selecionar uma liga!",
                    display: "none",
                    titulo: "Atenção"
                });
                setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            }
            else {
                setExisteDadosJogador(false);
                setIsLoading(true);
                await CarregarDadosFranquia();
                await CarregarDadosPorcentagem();
                if (codigoTemporada > 0) {
                    CarregarDadosSalariosCalouros();
                }
            }
        }
        fetchData();
    }, [codigoLiga, sem_Relogio_Calouro, sem_Relogio_Inicial, draftCalourosAberta, draftInicialAberta, codigoFranquia, comissario, codigoTemporada]);

    const CarregarDadosFranquia = async () => {
        await FranquiaService.getByIdLigaIdUsuario(Number(codigoLiga))
            .then((result) => {
                setIsLoading(false);
                let franquia = result.dado;
                formRef.current?.setData(franquia);
                setFranquia(franquia);
                setCodigoFranquia(franquia.codigo);
                setComissario(franquia.comissario);

                if (draftCalourosAberta || draftInicialAberta) {
                    setSorteioRealizado(true);
                    setMinhaVezEscolhaCalouros(false);
                    CarregarDropListaJogadoresInicial(Number(codigoLiga), Number(franquia.codigo_Temporada));
                    CarregarTabelaDraftJogadoresInicial(Number(codigoLiga), Number(franquia.codigo_Temporada), Number(franquia.codigo));
                    CarregarDropListaJogadoresCalouros(Number(codigoLiga), Number(franquia.codigo_Temporada));
                    CarregarTabelaDraftJogadoresCalouros(Number(codigoLiga), Number(franquia.codigo_Temporada));
                }

            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão Expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    if (errors.response.data.mensagem !== undefined) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
    }

    const CarregarDropListaJogadoresInicial = async (codLiga: number, codTemporada: number) => {
        await JogadorService.getBuscarTodoDraftInicialResumidoTemporada(codLiga, codTemporada)
            .then((result) => {
                setIsLoading(false);
                let lstAux = result.dado.sort((a, b) => a.nome > b.nome ? 1 : -1);
                //setListaJogadoresInicial(lstAux);
                const lstDrop: TDropOptions[] = lstAux.map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
                setOpcoesAutoCompleteJogadorInicial(lstDrop);
            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");

                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
            });
    }

    const CarregarDropListaJogadoresCalouros = async (codLiga: number, codTemporada: number) => {
        await JogadorService.getBuscarTodoDraftTemporada(codLiga, codTemporada)
            .then((result) => {
                setIsLoading(false);
                const lstDrop: TDropOptions[] = result.data.dado.sort((a, b) => a.nome > b.nome ? 1 : -1)
                    .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
                setOpcoesAutoCompleteJogadorCalouros(lstDrop);
            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");

                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
            });
    }

    const CarregarTabelaDraftJogadoresInicial = async (codLiga: number, codTemporada: number, codigoFranquia: number) => {

        await DraftService.getBuscarPicksDraftLigaResumoInicial(codLiga, codTemporada)
            .then((result) => {
                setShowModalMensagem(false);
                setIsLoading(false);
                let resultado = result.data.dado;
                let dadosAtual = resultado.find(f => f.escolha_Atual === true);
                if (dadosAtual !== undefined) {

                    setEscolhaAtual(dadosAtual?.escolha);
                    setMinhaVezEscolha(dadosAtual?.codigo_Franquia === codigoFranquia || comissario ? true : false);
                    setCodigoFranquiaEscolhaInicial(dadosAtual?.codigo_Franquia);

                    //valDataFinalEscolha = dadosAtual?.data_Escolha_Fim !== undefined ? dadosAtual?.data_Escolha_Fim : new Date();
                    setDataFinalEscolha(dadosAtual?.data_Escolha_Fim !== undefined ? dadosAtual?.data_Escolha_Fim : new Date());
                    setShowImagemFranquia(dadosAtual?.foto_Franquia === null ? "../../../semimagemescudo.png" : dadosAtual?.foto_Franquia);
                    setNome_Franquia(dadosAtual?.nome_Franquia !== undefined ? dadosAtual?.nome_Franquia : "Sem Nome");
                    // console.log("dadosAtual");
                    // console.log(dadosAtual);
                    if (dadosAtual?.data_Escolha_Inicio !== null && dadosAtual?.data_Escolha_Inicio !== undefined) {

                        let dataFinalEscolha = dadosAtual?.data_Escolha_Fim !== undefined ? dadosAtual?.data_Escolha_Fim : new Date();
                        let dataInicio = dadosAtual?.data_Escolha_Inicio;
                        let dataFinalAtual = addHours(new Date(dataInicio), tempo_Escolha_Inicial);
                        let data = dataFinalEscolha !== null ? dataFinalEscolha.toLocaleString("pt-BR").split("T") : dataFinalAtual.toLocaleString("pt-BR").split("T");
                        if (data[0].length > 1) {
                            let newDate = data[0].split("-")
                            let time = data[1].split(":");
                            let dataFinal = ` ${newDate[2]}/${newDate[1]}/${newDate[0]} ${time[0]}:${time[1]}`;
                            setDataLimiteEscolhaInicial(dataFinal);
                        }
                        else {
                            let newDate = data[0].split("-");
                            let dataFinal = ` ${newDate[2]}/${newDate[1]}/${newDate[0]}`;
                            setDataLimiteEscolhaInicial(dataFinal);
                        }

                    }
                    setEscolhasInicialRows(resultado);
                }
                setRemoveLoading(true);

            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados do Draft. Favor tentar mais tarde e caso o problema persista, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const CarregarTabelaDraftJogadoresCalouros = async (codLiga: number, codTemporada: number) => {
        await DraftService.getBuscarPicksDraftLigaResumoCalouros(codLiga, codTemporada)
            .then((result) => {
                setShowModalMensagem(false);
                setIsLoading(false);
                let resultado = result.data.dado;
                let dadosAtual = resultado.find(f => f.escolha_Atual === true);
                // console.log("dadosAtual");
                // console.log(dadosAtual);
                if (dadosAtual !== undefined) {

                    setEscolhaAtualCalouros(dadosAtual !== undefined ? dadosAtual?.escolha : 0);
                    setCodigoFranquiaEscolha(dadosAtual?.codigo_Franquia);
                    setMinhaVezEscolhaCalouros(dadosAtual?.codigo_Franquia === codigoFranquia || comissario ? true : false);

                    //valDataFinalEscolha = dadosAtual?.data_Escolha_Fim !== undefined ? dadosAtual?.data_Escolha_Fim : new Date();
                    setDataFinalEscolhaCalouros(dadosAtual?.data_Escolha_Fim !== undefined ? dadosAtual?.data_Escolha_Fim : new Date());
                    setShowImagemFranquiaCalouro(dadosAtual?.foto_Franquia === null ? "../../../semimagemescudo.png" : dadosAtual?.foto_Franquia);
                    setNome_FranquiaCalouro(dadosAtual?.nome_Franquia !== undefined ? dadosAtual?.nome_Franquia : "Sem Nome");
                    // console.log(dadosAtual);
                    if (dadosAtual?.data_Escolha_Inicio !== null && dadosAtual?.data_Escolha_Inicio !== undefined) {

                        let dataFinalEscolha = dadosAtual?.data_Escolha_Fim !== null && dadosAtual?.data_Escolha_Fim !== undefined ? dadosAtual?.data_Escolha_Fim : new Date();
                        let dataInicio = dadosAtual?.data_Escolha_Inicio !== null ? dadosAtual?.data_Escolha_Inicio : new Date();
                        let dataFinalAtual = dataFinalEscolha !== null ? new Date(dataFinalEscolha) : addHours(new Date(dataInicio), tempo_Escolha_Calouro);
                        setDataLimiteEscolhaCalouro(dataFinalAtual.toLocaleString("pt-BR").replace(",", ""));
                    }

                    //         let newDate = data[0].split("-")
                    //         let time = data[1].split(":");
                    //         let dataFinal = ` ${newDate[2]}/${newDate[1]}/${newDate[0]} ${time[0]}:${time[1]}`;
                    //         setDataLimiteEscolha(dataFinal);

                    //     }
                    //     else {
                    //         let newDate = data[0].split("-");
                    //         let dataFinal = ` ${newDate[2]}/${newDate[1]}/${newDate[0]}`;
                    //         setDataLimiteEscolha(dataFinal);

                    //     }
                    //     let horaAtual = new Date();
                    //     if (periodoInicial.length > 0 && periodoFinal.length > 0) {

                    //         let horaDraftInicio = new Date().setHours(Number(periodoInicial.split(":")[0]), Number(periodoInicial.split(":")[1]), 0);
                    //         let horaDraftFinal = new Date().setHours(Number(periodoFinal.split(":")[0]), Number(periodoFinal.split(":")[1]), 0);
                    //         let horaIniEscolhas = new Date(horaDraftInicio);
                    //         let horaFinEscolhas = new Date(horaDraftInicio);

                    //         setDataFinalEscolhaCalouros(dataFinalAtual);
                    //         setShowCalourosEscolha(horaIniEscolhas <= horaAtual && horaFinEscolhas <= horaAtual);
                    //     }
                    //     else {
                    //         setDataFinalEscolhaCalouros(dadosAtual?.data_Escolha_Fim !== undefined ? dadosAtual?.data_Escolha_Fim : dataFinalAtual);
                    //     }
                    // }
                    setEscolhasCalourosRows(resultado);
                }
                setRemoveLoading(true);
            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados dos jogadores! Favor tentar novamente.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const handleCarregarDadosJogadorInicial = async (codigoJogador: any) => {
        setRemoveLoading(false);
        setIsLoading(true);
        let dados: any = {};
        if (codigoJogador === undefined) {
            setIsLoading(false);
            setRemoveLoading(true);
            return;
        }
        await JogadorService.getBuscarDadosJogadorInicial(Number(codigoLiga), Number(codigoTemporada), codigoJogador)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                dados = result.dado;
                //console.log(dados);
                setListaJogadoresInicial(dados);
            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
            });

        if (dados !== undefined) {

            const lst: IDadosEstatisticas[] = [];
            lst.push(dados);
            // console.log("lst");
            // console.log(lst);
            setLstDadosJogador(lst);
            setDadosJogador(dados);
            setFotoJogador(dados.foto);
            setNomeJogador(dados.nome);
        }
        else {
            setIsLoading(false);
            setShowModalMensagem(true);
            setRemoveLoading(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Dados do jogador não encontrado! Favor tentar novamente mais tarde.",
                display: "none",
                titulo: "Atenção"
            });
            logout();
            setRedirecionar("0");
            return;

        }
        setExisteDadosJogador(true);
        DraftService.getDadosJogadorSelecionadoInicial(codigoJogador, Number(codigoFranquiaEscolhaInicial), Number(escolhaAtual))
            .then((result) => {
                setIsLoading(false);
                const dados = result.dado;
                setFotoJogador(dados.foto_Jogador);
                setNomeJogador(dados.nome_Jogador);
                setFranquiaJogador(dados.nome_Franquia);
                setShowBotaoEscolherInicial(Number(dados.salario1) !== 0);                
                setSalario1(dados.salario1);
                setSalario2(dados.salario2);
                setSalario3(dados.salario3);
                setSalario4(dados.salario4);
                setSalario5(dados.salario5);

                var lstStats = dados.stats_Liga.reduce((unique: IDadosStats[], o) => {
                    if (!unique.some(obj => obj.nome === o.nome)) {
                        unique.push(o);
                    }
                    return unique;
                }, []);

                setListaStats(lstStats);

                setExisteDadosJogador(true);
                //CarregarTabelaDraftJogadores(null, null, null);
                setRemoveLoading(true);
            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
            });
    }

    const handleCarregarDadosJogadorCalouro = async (codigo: any) => {
        setRemoveLoading(true);
        if (codigo === undefined) {
            return;
        }
        await DraftService.getDadosJogadorSelecionadoCalouro(codigo, Number(franquia?.codigo))
            .then((result) => {
                setIsLoading(false);
                const dados = result.dado;
                setFotoJogador(dados.foto_Jogador);
                setNomeJogador(dados.nome_Jogador);
                setFranquiaJogador(dados.nome_Franquia);
                setSalario1Calouro(dados.salario1);
                setSalario2Calouro(dados.salario2);
                setSalario3Calouro(dados.salario3);
                setSalario4Calouro(dados.salario4);
                setSalario5Calouro(dados.salario5);

                var lstStats = dados.stats_Liga.reduce((unique: IDadosStats[], o) => {
                    if (!unique.some(obj => obj.nome === o.nome)) {
                        unique.push(o);
                    }
                    return unique;
                }, []);

                let obj: any[] = [{
                    codigo: codigo,
                    codigo_NBA: 0,
                    nome: dados.nome_Jogador,
                    //quantidade_Jogos: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "minutos").length >= 0  ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "minutos")?.peso_Padrao : null,
                    minutos: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "minutos").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "minutos")?.peso_Padrao : null,
                    arremessos: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "minutos").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "arremessos")?.peso_Padrao : null,
                    lance_Livre: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "lance_livre").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "lance_livre")?.peso_Padrao : null,
                    tres_Pontos: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "tres_pontos").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "tres_pontos")?.peso_Padrao : null,
                    pontos: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "pontos").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "pontos")?.peso_Padrao : null,
                    rebotes: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "rebotes").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "rebotes")?.peso_Padrao : null,
                    rebotes_Ofensivos: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "rebotes_ofensivos").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "rebotes_ofensivos")?.peso_Padrao : null,
                    rebotes_Defensivos: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "rebotes_defensivos").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "rebotes_defensivos")?.peso_Padrao : null,
                    assistencias: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "assistencias").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "assistencias")?.peso_Padrao : null,
                    steal: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "steal").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "steal")?.peso_Padrao : null,
                    bloqueios: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "bloqueios").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "bloqueios")?.peso_Padrao : null,
                    turnovers: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "turnovers").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "turnovers")?.peso_Padrao : null,
                    faltas: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "faltas").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "faltas")?.peso_Padrao : null,
                    min_Plus: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "min_plus").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "min_plus")?.peso_Padrao : null,
                    porcentagem_Arremessos: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "porcentagem_arremessos").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "porcentagem_arremessos")?.peso_Padrao : null,
                    porcentagem_Lance_Livre: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "porcentagem_lance_livre").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "porcentagem_lance_livre")?.peso_Padrao : null,
                    porcentagem_Tres_Pontos: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "porcentagem_tres_pontos").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "porcentagem_tres_pontos")?.peso_Padrao : null,
                    peso_Total_Jogador: dados.stats_Liga.filter(m => m.descricao.toLowerCase() === "peso_total_jogador").length >= 0 ? dados.stats_Liga.find(m => m.descricao.toLowerCase() === "peso_total_jogador")?.peso_Padrao : null,

                }];

                setListaDataGridCalouro(obj);
                setListaStats(lstStats);
                setExisteDadosJogador(true);
                setRemoveLoading(true);
            }).catch((errors) => {
                setIsLoading(false);

                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
            });
    }

    const handleEscolherJogadorCalouros = () => {
        setIsLoading(true);
        let dadosSalvar: IDadosSalvarJogadorDraftCalouros = {
            codigo_Franquia_Dono: comissario ? codigoFranquiaEscolha : Number(franquia?.codigo),
            codigo_Jogador_Escolhido: Number(selectedIdCompleteCalouros),
            codigo_Temporada: Number(codigoTemporada),
            posicao_Final: Number(escolhaAtualCalouros),
            codUsuCriacao: user.codUsuario
        }

        //console.log(dadosSalvar);
        DraftService.updateDadosDraftCalouros(dadosSalvar)
            .then((result) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Draft realizado com sucesso!",
                    display: "none",
                    titulo: "Sucesso"
                });

                setRedirecionar("0");

            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");

                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
            });
    }

    const handleEscolherJogadorInicial = () => {
        setIsLoading(true);
        let dadosSalvar: IDadosSalvarJogadorDraftInicial = {
            codigo_Franquia_Dono: comissario ? codigoFranquiaEscolhaInicial : Number(franquia?.codigo),
            codigo_Jogador_Escolhido: Number(selectedIdCompleteInicial),
            codigo_Liga: Number(codigoLiga),
            posicao_Geral: Number(escolhaAtual),
            codUsuCriacao: user.codUsuario
        }

        DraftService.updateDadosDraftInicial(dadosSalvar)
            .then((result) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Draft realizado com sucesso!",
                    display: "none",
                    titulo: "Sucesso"
                });

                setRedirecionar("0");

            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
            });
    }

    const CarregarDadosSalariosCalouros = async () => {
        await carregarCabecalhoTemporadas(codigoTemporadaSalario);
        await DraftService.getDadosSalarioCalouros(Number(codigoLiga), codigoTemporadaSalario, codigoFranquiaFiltro, codigoRodadaFiltro)
            .then((result) => {
                setShowModalMensagem(false);
                setIsLoading(false);
                let resultado = result.dado;
                // console.log("resultado SALARIOS");
                // console.log(resultado);
                setRowsSalario(resultado);
                setRemoveLoading(true);

            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const CarregarDadosPorcentagem = async () => {
        await DraftService.getDraftPorcentagemEscolhaById(Number(codigoLiga))
            .then((result) => {
                setShowModalMensagem(false);
                setIsLoading(false);
                let resultado = result.dado;
                SetListaDataGridPorcentagemEscolha(resultado === null ? [] : resultado);
            }).catch((errors) => {

                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados do sorteio! Favor tentar novamente. Caso o problema persista, entrar em contato com a TI",
                    display: "none",
                    titulo: "Atenção"
                });

            });
    }

    const CarregarDadosSorteioCalouros = async () => {
        await DraftService.getDraftSorteioById(Number(codigoLiga))
            .then((result) => {
                setShowModalMensagem(false);
                let resultado = result.dado;
                setDataUltimoSorteio(resultado.data_Proximo_Sorteio);
                setRowsSorteiosPicks(resultado.informacoes_Loteria);
                setSorteioRealizado(resultado.sorteio_Realizado);
                setSorteioFinalizado(resultado.sorteio_Finalizado);                
                if ((!tempoZerado || !resultado.sorteio_Finalizado) && resultado.sorteio_Realizado) {                    
                    UseCountdown(resultado.data_Proximo_Sorteio, resultado.sorteio_Realizado);
                    setTempoZerado(false);
                }
            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados do sorteio! Favor tentar novamente. Caso o problema persista, entrar em contato com a TI",
                    display: "none",
                    titulo: "Atenção"
                });

            });
    }

    const paginaEscolha = useMemo(() => {
        return Number(searchParamsEscolha.get("pagina") || "0");
    }, [searchParamsEscolha]);
    //#endregion

    //#region Salários
    const [searchParamsSalarios, SetSearchParams] = useSearchParams();
    const [dadosHeader, setDadosHeader] = useState<IGridColumnHeaderParams>({
        pick: "",
        nome_Franquia_Original: "",
        logo_Fraqnuia_Dono: "",
        nome_Franquia_Dono: "",
        restrito: false, ano1: "", ano2: "", ano3: "", ano4: "", ano5: "", ano6: ""
    });

    const [columnsSalarios, setColumnsSalarios] = useState<GridColDef[]>([]);
    const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options);

    const carregarCabecalhoTemporadas = async (codigo: number) => {
        UtilidadeService.getDescricaoTemporadoPorCodigoTemporada(codigo)
            .then((result) => {
                setIsLoading(false);
                const tmps = result.dado;
                setDadosHeader({
                    pick: "",
                    nome_Franquia_Original: "",
                    logo_Fraqnuia_Dono: "",
                    nome_Franquia_Dono: "",
                    restrito: false,
                    ano1: tmps.descricao_Ano1,
                    ano2: tmps.descricao_Ano2,
                    ano3: tmps.descricao_Ano3,
                    ano4: tmps.descricao_Ano4,
                    ano5: tmps.descricao_Ano5,
                    ano6: tmps.descricao_Ano6
                });
                setColumnsSalarios([
                    {
                        field: `pick`,
                        headerName: `PICK`,
                        width: 50,
                        sortable: UtilidadeService.isMobile() ? false : true,
                        editable: false,
                        align: "center",
                        headerAlign: "center",
                        headerClassName: 'super-app-theme--header',
                    }, {
                        field: `nome_Franquia_Origem`,
                        headerName: `FRANQUIA ORIGEM`,
                        width: UtilidadeService.isMobile() ? 110 : 140,
                        headerAlign: "center",
                        editable: false,
                        sortable: UtilidadeService.isMobile() ? false : true,
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => {
                            return (
                                <Box
                                    sx={{
                                        whiteSpace: 'pre-wrap',
                                    }}
                                >
                                    {params.value}
                                </Box>
                            );
                        },
                    }, {
                        field: `logo_Franquia_Dono`,
                        headerName: `LOGO`,
                        width: 78,
                        editable: false,
                        sortable: UtilidadeService.isMobile() ? false : true,
                        align: "center",
                        headerAlign: "center",
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => <img src={params.value !== null ? params.value : semImagemFranquia} width={45} height={50} />,

                    }, {
                        field: `nome_Franquia_Dono`,
                        headerName: `FRANQUIA DONO`,
                        minWidth: UtilidadeService.isMobile() ? 110 : 125,
                        flex: 1,
                        sortable: UtilidadeService.isMobile() ? false : true,
                        editable: false,
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => {
                            return (
                                <Box
                                    sx={{
                                        whiteSpace: 'pre-wrap',
                                    }}
                                >
                                    {params.value}
                                </Box>
                            );
                        },
                    }, {
                        field: `restrito`,
                        headerName: `RESTRITO`,
                        flex: 1,
                        minWidth: 98,
                        sortable: UtilidadeService.isMobile() ? false : true,
                        editable: false,
                        headerAlign: "center",
                        align: "center",
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => (!params.value ? "NÃO" : "SIM")
                    }, {
                        field: `ano1`,
                        headerName: `${tmps.descricao_Ano1}`,
                        flex: 1,
                        minWidth: UtilidadeService.isMobile() ? 110 : 125,
                        sortable: UtilidadeService.isMobile() ? false : true,
                        editable: false,
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => {
                            return (
                                <Box
                                    sx={{
                                        color: TipoSalario.find(f => f.codigo === params.row.tipo_Salario1)?.color,
                                    }}
                                >
                                    {(params.value > 0 ? formatNumber.format(params.value) : "")}
                                </Box>
                            );

                        }
                    }, {
                        field: `ano2`,
                        headerName: `${tmps.descricao_Ano2}`,
                        flex: 1,
                        minWidth: UtilidadeService.isMobile() ? 110 : 125,
                        sortable: UtilidadeService.isMobile() ? false : true,
                        editable: false,
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => {
                            return (
                                <Box
                                    sx={{
                                        color: TipoSalario.find(f => f.codigo === params.row.tipo_Salario2)?.color,
                                    }}
                                >
                                    {(params.value > 0 ? formatNumber.format(params.value) : "")}
                                </Box>
                            );

                        }
                    }, {
                        field: `ano3`,
                        headerName: `${tmps.descricao_Ano3}`,
                        flex: 1,
                        minWidth: UtilidadeService.isMobile() ? 110 : 125,
                        sortable: UtilidadeService.isMobile() ? false : true,
                        editable: false,
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => {
                            return (
                                <Box
                                    sx={{
                                        color: TipoSalario.find(f => f.codigo === params.row.tipo_Salario3)?.color,
                                    }}
                                >
                                    {(params.value > 0 ? formatNumber.format(params.value) : "")}
                                </Box>
                            );

                        }
                    }, {
                        field: `ano4`,
                        headerName: `${tmps.descricao_Ano4}`,
                        flex: 1,
                        minWidth: UtilidadeService.isMobile() ? 110 : 125,
                        sortable: UtilidadeService.isMobile() ? false : true,
                        editable: false,
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => {
                            return (
                                <Box
                                    sx={{
                                        color: TipoSalario.find(f => f.codigo === params.row.tipo_Salario4)?.color,
                                    }}
                                >
                                    {(params.value > 0 ? formatNumber.format(params.value) : "")}
                                </Box>
                            );

                        }
                    }, {
                        field: `ano5`,
                        headerName: `${tmps.descricao_Ano5}`,
                        flex: 1,
                        minWidth: UtilidadeService.isMobile() ? 110 : 125,
                        sortable: UtilidadeService.isMobile() ? false : true,
                        editable: false,
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => {
                            return (
                                <Box
                                    sx={{
                                        color: TipoSalario.find(f => f.codigo === params.row.tipo_Salario5)?.color,
                                    }}
                                >
                                    {(params.value > 0 ? formatNumber.format(params.value) : "")}
                                </Box>
                            );

                        }
                    }
                    // , {
                    //     field: `ano6`,
                    //     headerName: `${tmps.descricao_Ano6}`,
                    //     flex: 1,
                    //     width: 150,
                    //     editable: false,
                    //     headerClassName: 'super-app-theme--header',
                    // },
                ])
            })
            .catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "15- Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
            });
    }

    const paginaSalarios = useMemo(() => {
        return Number(searchParamsSalarios.get("pagina") || "1");
    }, [searchParamsSalarios]);

    
    //#endregion

    const toggleModalMensagem = () => {

        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar.length >= 1) {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar === "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleSave = async (dados: IDetalheFranquia) => {
        setIsLoading(true);
        setIsLoading(false);

    };

    const handleEscondeDadosJogador = () => {
        setExisteDadosJogador(false);
    }

    const columnsGeralCalouro: GridColDef[] = [
        {
            field: 'codigo',
            headerName: UtilidadeService.isMobile() ? 'COD' : "CÓDIGO",
            flex: 1,
            minWidth: 58,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            sortable: false,

        },       
        {
            field: 'minutos',
            headerName: 'MIN',
            editable: false,
            flex: 1,
            minWidth: 60,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null

        },
        {
            field: 'arremessos',
            headerName: 'FGM',
            editable: false,
            flex: 1,
            minWidth: 60,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'lance_Livre',
            headerName: 'FTM',
            editable: false,
            flex: 1,
            minWidth: 60,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            hideable: true,
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'tres_Pontos',
            headerName: '3PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null

        },
        {
            field: 'pontos',
            headerName: 'PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            //renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'rebotes',
            headerName: 'REB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'rebotes_Ofensivos',
            headerName: 'OREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'rebotes_Defensivos',
            headerName: 'DREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'assistencias',
            headerName: 'AST',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'steal',
            headerName: 'STL',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'bloqueios',
            headerName: 'BLK',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null

        },
        {
            field: 'turnovers',
            headerName: 'TO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'faltas',
            headerName: 'PF',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'min_Plus',
            headerName: 'MPLU',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'arremessos_errados',
            headerName: 'FGE',
            editable: false,
            flex: 1,
            minWidth: 60,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'lance_Livre_Errados',
            headerName: 'FTE',
            editable: false,
            flex: 1,
            minWidth: 60,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            hideable: true,
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'tres_Pontos_errados',
            headerName: '3PE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null

        },        
        {
            field: 'stocks',
            headerName: 'STKS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null

        },
        {
            field: 'porcentagem_Arremessos',
            headerName: 'FGM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'porcentagem_Lance_Livre',
            headerName: 'FTM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null
        },
        {
            field: 'porcentagem_Tres_Pontos',
            headerName: '3P%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null

        },
        {
            field: 'peso_Total_Jogador',
            headerName: 'PESO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 78,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value : null

        }
    ];

    const columnsGeralPorcentagem: GridColDef[] = [
        {
            field: 'codigo_Franquia_Original',
            headerName: UtilidadeService.isMobile() ? 'COD' : "CÓDIGO",
            flex: 1,
            minWidth: 58,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'logo_Franquia_Dono',
            headerName: '',
            hideable: false,
            minWidth: UtilidadeService.isMobile() ? 45 : 65,
            // maxWidth: 65,
            flex: 1,
            renderCell: (params) => <img src={params.value !== null ? params.value : semImagemFranquia} width={UtilidadeService.isMobile() ? 25 : 45} height={UtilidadeService.isMobile() ? 30 : 50} />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'nome_Franquia_Dono',
            headerName: 'FRANQUIA DONO',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                const color = params.row.posicao <= 8 ? "auto" : "#4864E8";
                return (
                    <Box
                        sx={{
                            color: color,
                            fontWeight: 'bold',
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'logo_Franquia_Original',
            headerName: '',
            hideable: false,
            minWidth: UtilidadeService.isMobile() ? 45 : 65,
            // maxWidth: 65,
            flex: 1,
            renderCell: (params) => <img src={params.value !== null ? params.value : semImagemFranquia} width={UtilidadeService.isMobile() ? 25 : 45} height={UtilidadeService.isMobile() ? 30 : 50} />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'nome_Franquia_Original',
            headerName: 'FRANQUIA ORIGINAL',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                const color = params.row.posicao <= 8 ? "auto" : "#4864E8";
                return (
                    <Box
                        sx={{
                            color: color,
                            fontWeight: 'bold',
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'porcentagem_Primeira_Escolha',
            headerName: '%',
            headerClassName: 'super-app-theme--header',
            editable: false,
            flex: 1,
            minWidth: 35,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
    ];

    const columnsGeral: GridColDef[] = [
        {
            field: 'codigo',
            headerName: UtilidadeService.isMobile() ? 'COD' : "CÓDIGO",
            flex: 1,
            minWidth: 58,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            sortable: false,

        },
        // {
        //   field: 'descricao_Temporada',
        //   headerName: 'TEMP',
        //   headerClassName: 'super-app-theme--header',
        //   flex: 1,
        //   minWidth: 100,
        //   sortable: false,
        //   editable: false,
        //   align: 'center',
        //   headerAlign: 'center'
        // },

        {
            field: 'quantidade_Jogos',
            headerName: 'QTD',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            editable: false,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'minutos',
            headerName: 'MIN',
            editable: false,
            flex: 1,
            minWidth: 60,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : null

        },
        {
            field: 'arremessos',
            headerName: 'FGM',
            editable: false,
            flex: 1,
            minWidth: 60,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'lance_Livre',
            headerName: 'FTM',
            editable: false,
            flex: 1,
            minWidth: 60,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            hideable: true,
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'tres_Pontos',
            headerName: '3PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null

        },

        {
            field: 'pontos',
            headerName: 'PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'rebotes',
            headerName: 'REB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'rebotes_Ofensivos',
            headerName: 'OREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'rebotes_Defensivos',
            headerName: 'DREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'assistencias',
            headerName: 'AST',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'steal',
            headerName: 'STL',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'bloqueios',
            headerName: 'BLK',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null

        },
        {
            field: 'turnovers',
            headerName: 'TO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'faltas',
            headerName: 'PF',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'min_Plus',
            headerName: 'MPLU',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'arremessos_Errados',
            headerName: 'FGE',
            editable: false,
            flex: 1,
            minWidth: 60,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'lance_Livre_Errados',
            headerName: 'FTE',
            editable: false,
            flex: 1,
            minWidth: 60,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            hideable: true,
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null
        },
        {
            field: 'tres_Pontos_Errados',
            headerName: '3PE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null

        },        
        {
            field: 'stocks',
            headerName: 'STKS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(0) : null

        },
        {
            field: 'porcentagem_Arremessos',
            headerName: 'FGM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : null
        },
        {
            field: 'porcentagem_Lance_Livre',
            headerName: 'FTM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : null
        },
        {
            field: 'porcentagem_Tres_Pontos',
            headerName: '3P%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 70,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : null

        },
        {
            field: 'peso_Total_Jogador',
            headerName: 'PESO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 78,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : null

        }
    ];

    const Pesquisar = () => {
        CarregarDadosSalariosCalouros();
    }

    //#region Sorterio Picks
    //#region variaveis



    const [hora0, setHora0] = useState<number>(0);
    const [minuto0, setMinuto0] = useState<number>(0);
    const [segundo0, setSegundo0] = useState<number>(0);

    const [hora1, setHora1] = useState<number>(0);
    const [minuto1, setMinuto1] = useState<number>(0);
    const [segundo1, setSegundo1] = useState<number>(0);

    const [hora2, setHora2] = useState<number>(0);
    const [minuto2, setMinuto2] = useState<number>(0);
    const [segundo2, setSegundo2] = useState<number>(0);

    const [hora3, setHora3] = useState<number>(0);
    const [minuto3, setMinuto3] = useState<number>(0);
    const [segundo3, setSegundo3] = useState<number>(0);

    const [hora4, setHora4] = useState<number>(0);
    const [minuto4, setMinuto4] = useState<number>(0);
    const [segundo4, setSegundo4] = useState<number>(0);

    const [hora5, setHora5] = useState<number>(0);
    const [minuto5, setMinuto5] = useState<number>(0);
    const [segundo5, setSegundo5] = useState<number>(0);

    const [hora6, setHora6] = useState<number>(0);
    const [minuto6, setMinuto6] = useState<number>(0);
    const [segundo6, setSegundo6] = useState<number>(0);

    const [hora7, setHora7] = useState<number>(0);
    const [minuto7, setMinuto7] = useState<number>(0);
    const [segundo7, setSegundo7] = useState<number>(0);

    const [hora8, setHora8] = useState<number>(0);
    const [minuto8, setMinuto8] = useState<number>(0);
    const [segundo8, setSegundo8] = useState<number>(0);

    const [hora9, setHora9] = useState<number>(0);
    const [minuto9, setMinuto9] = useState<number>(0);
    const [segundo9, setSegundo9] = useState<number>(0);

    const [hora10, setHora10] = useState<number>(0);
    const [minuto10, setMinuto10] = useState<number>(0);
    const [segundo10, setSegundo10] = useState<number>(0);

    const [hora11, setHora11] = useState<number>(0);
    const [minuto11, setMinuto11] = useState<number>(0);
    const [segundo11, setSegundo11] = useState<number>(0);

    const [hora12, setHora12] = useState<number>(0);
    const [minuto12, setMinuto12] = useState<number>(0);
    const [segundo12, setSegundo12] = useState<number>(0);

    const [hora13, setHora13] = useState<number>(0);
    const [minuto13, setMinuto13] = useState<number>(0);
    const [segundo13, setSegundo13] = useState<number>(0);

    const [hora14, setHora14] = useState<number>(0);
    const [minuto14, setMinuto14] = useState<number>(0);
    const [segundo14, setSegundo14] = useState<number>(0);

    const [hora15, setHora15] = useState<number>(0);
    const [minuto15, setMinuto15] = useState<number>(0);
    const [segundo15, setSegundo15] = useState<number>(0);

    const [hora16, setHora16] = useState<number>(0);
    const [minuto16, setMinuto16] = useState<number>(0);
    const [segundo16, setSegundo16] = useState<number>(0);

    const [hora17, setHora17] = useState<number>(0);
    const [minuto17, setMinuto17] = useState<number>(0);
    const [segundo17, setSegundo17] = useState<number>(0);

    const [hora18, setHora18] = useState<number>(0);
    const [minuto18, setMinuto18] = useState<number>(0);
    const [segundo18, setSegundo18] = useState<number>(0);

    const [hora19, setHora19] = useState<number>(0);
    const [minuto19, setMinuto19] = useState<number>(0);
    const [segundo19, setSegundo19] = useState<number>(0);

    const [hora20, setHora20] = useState<number>(0);
    const [minuto20, setMinuto20] = useState<number>(0);
    const [segundo20, setSegundo20] = useState<number>(0);

    const [hora21, setHora21] = useState<number>(0);
    const [minuto21, setMinuto21] = useState<number>(0);
    const [segundo21, setSegundo21] = useState<number>(0);

    const [hora22, setHora22] = useState<number>(0);
    const [minuto22, setMinuto22] = useState<number>(0);
    const [segundo22, setSegundo22] = useState<number>(0);

    const [hora23, setHora23] = useState<number>(0);
    const [minuto23, setMinuto23] = useState<number>(0);
    const [segundo23, setSegundo23] = useState<number>(0);

    const [hora24, setHora24] = useState<number>(0);
    const [minuto24, setMinuto24] = useState<number>(0);
    const [segundo24, setSegundo24] = useState<number>(0);

    const [hora25, setHora25] = useState<number>(0);
    const [minuto25, setMinuto25] = useState<number>(0);
    const [segundo25, setSegundo25] = useState<number>(0);

    const [hora26, setHora26] = useState<number>(0);
    const [minuto26, setMinuto26] = useState<number>(0);
    const [segundo26, setSegundo26] = useState<number>(0);

    const [hora27, setHora27] = useState<number>(0);
    const [minuto27, setMinuto27] = useState<number>(0);
    const [segundo27, setSegundo27] = useState<number>(0);

    const [hora28, setHora28] = useState<number>(0);
    const [minuto28, setMinuto28] = useState<number>(0);
    const [segundo28, setSegundo28] = useState<number>(0);

    const [hora29, setHora29] = useState<number>(0);
    const [minuto29, setMinuto29] = useState<number>(0);
    const [segundo29, setSegundo29] = useState<number>(0);

    const [hora30, setHora30] = useState<number>(0);
    const [minuto30, setMinuto30] = useState<number>(0);
    const [segundo30, setSegundo30] = useState<number>(0);

    const [hora31, setHora31] = useState<number>(0);
    const [minuto31, setMinuto31] = useState<number>(0);
    const [segundo31, setSegundo31] = useState<number>(0);

    const [hora32, setHora32] = useState<number>(0);
    const [minuto32, setMinuto32] = useState<number>(0);
    const [segundo32, setSegundo32] = useState<number>(0);

    const [hora33, setHora33] = useState<number>(0);
    const [minuto33, setMinuto33] = useState<number>(0);
    const [segundo33, setSegundo33] = useState<number>(0);

    const [hora34, setHora34] = useState<number>(0);
    const [minuto34, setMinuto34] = useState<number>(0);
    const [segundo34, setSegundo34] = useState<number>(0);

    const [hora35, setHora35] = useState<number>(0);
    const [minuto35, setMinuto35] = useState<number>(0);
    const [segundo35, setSegundo35] = useState<number>(0);

    const [hora36, setHora36] = useState<number>(0);
    const [minuto36, setMinuto36] = useState<number>(0);
    const [segundo36, setSegundo36] = useState<number>(0);

    const [hora37, setHora37] = useState<number>(0);
    const [minuto37, setMinuto37] = useState<number>(0);
    const [segundo37, setSegundo37] = useState<number>(0);

    const [hora38, setHora38] = useState<number>(0);
    const [minuto38, setMinuto38] = useState<number>(0);
    const [segundo38, setSegundo38] = useState<number>(0);

    const [hora39, setHora39] = useState<number>(0);
    const [minuto39, setMinuto39] = useState<number>(0);
    const [segundo39, setSegundo39] = useState<number>(0);

    const [hora40, setHora40] = useState<number>(0);
    const [minuto40, setMinuto40] = useState<number>(0);
    const [segundo40, setSegundo40] = useState<number>(0);

    const [hora41, setHora41] = useState<number>(0);
    const [minuto41, setMinuto41] = useState<number>(0);
    const [segundo41, setSegundo41] = useState<number>(0);

    const [hora42, setHora42] = useState<number>(0);
    const [minuto42, setMinuto42] = useState<number>(0);
    const [segundo42, setSegundo42] = useState<number>(0);

    const [hora43, setHora43] = useState<number>(0);
    const [minuto43, setMinuto43] = useState<number>(0);
    const [segundo43, setSegundo43] = useState<number>(0);

    const [hora44, setHora44] = useState<number>(0);
    const [minuto44, setMinuto44] = useState<number>(0);
    const [segundo44, setSegundo44] = useState<number>(0);

    const [hora45, setHora45] = useState<number>(0);
    const [minuto45, setMinuto45] = useState<number>(0);
    const [segundo45, setSegundo45] = useState<number>(0);

    const [hora46, setHora46] = useState<number>(0);
    const [minuto46, setMinuto46] = useState<number>(0);
    const [segundo46, setSegundo46] = useState<number>(0);

    const [hora47, setHora47] = useState<number>(0);
    const [minuto47, setMinuto47] = useState<number>(0);
    const [segundo47, setSegundo47] = useState<number>(0);

    const [hora48, setHora48] = useState<number>(0);
    const [minuto48, setMinuto48] = useState<number>(0);
    const [segundo48, setSegundo48] = useState<number>(0);

    const [hora49, setHora49] = useState<number>(0);
    const [minuto49, setMinuto49] = useState<number>(0);
    const [segundo49, setSegundo49] = useState<number>(0);

    const [hora50, setHora50] = useState<number>(0);
    const [minuto50, setMinuto50] = useState<number>(0);
    const [segundo50, setSegundo50] = useState<number>(0);

    const [hora51, setHora51] = useState<number>(0);
    const [minuto51, setMinuto51] = useState<number>(0);
    const [segundo51, setSegundo51] = useState<number>(0);

    const [hora52, setHora52] = useState<number>(0);
    const [minuto52, setMinuto52] = useState<number>(0);
    const [segundo52, setSegundo52] = useState<number>(0);

    const [hora53, setHora53] = useState<number>(0);
    const [minuto53, setMinuto53] = useState<number>(0);
    const [segundo53, setSegundo53] = useState<number>(0);

    const [hora54, setHora54] = useState<number>(0);
    const [minuto54, setMinuto54] = useState<number>(0);
    const [segundo54, setSegundo54] = useState<number>(0);

    const [hora55, setHora55] = useState<number>(0);
    const [minuto55, setMinuto55] = useState<number>(0);
    const [segundo55, setSegundo55] = useState<number>(0);

    const [hora56, setHora56] = useState<number>(0);
    const [minuto56, setMinuto56] = useState<number>(0);
    const [segundo56, setSegundo56] = useState<number>(0);

    const [hora57, setHora57] = useState<number>(0);
    const [minuto57, setMinuto57] = useState<number>(0);
    const [segundo57, setSegundo57] = useState<number>(0);

    const [hora58, setHora58] = useState<number>(0);
    const [minuto58, setMinuto58] = useState<number>(0);
    const [segundo58, setSegundo58] = useState<number>(0);

    const [hora59, setHora59] = useState<number>(0);
    const [minuto59, setMinuto59] = useState<number>(0);
    const [segundo59, setSegundo59] = useState<number>(0);

    const [hora60, setHora60] = useState<number>(0);
    const [minuto60, setMinuto60] = useState<number>(0);
    const [segundo60, setSegundo60] = useState<number>(0);

    const [hora61, setHora61] = useState<number>(0);
    const [minuto61, setMinuto61] = useState<number>(0);
    const [segundo61, setSegundo61] = useState<number>(0);

    const [hora62, setHora62] = useState<number>(0);
    const [minuto62, setMinuto62] = useState<number>(0);
    const [segundo62, setSegundo62] = useState<number>(0);

    const [hora63, setHora63] = useState<number>(0);
    const [minuto63, setMinuto63] = useState<number>(0);
    const [segundo63, setSegundo63] = useState<number>(0);

    const [hora64, setHora64] = useState<number>(0);
    const [minuto64, setMinuto64] = useState<number>(0);
    const [segundo64, setSegundo64] = useState<number>(0);

    const [hora65, setHora65] = useState<number>(0);
    const [minuto65, setMinuto65] = useState<number>(0);
    const [segundo65, setSegundo65] = useState<number>(0);

    const [hora66, setHora66] = useState<number>(0);
    const [minuto66, setMinuto66] = useState<number>(0);
    const [segundo66, setSegundo66] = useState<number>(0);

    const [hora67, setHora67] = useState<number>(0);
    const [minuto67, setMinuto67] = useState<number>(0);
    const [segundo67, setSegundo67] = useState<number>(0);

    const [hora68, setHora68] = useState<number>(0);
    const [minuto68, setMinuto68] = useState<number>(0);
    const [segundo68, setSegundo68] = useState<number>(0);

    const [hora69, setHora69] = useState<number>(0);
    const [minuto69, setMinuto69] = useState<number>(0);
    const [segundo69, setSegundo69] = useState<number>(0);

    const [hora70, setHora70] = useState<number>(0);
    const [minuto70, setMinuto70] = useState<number>(0);
    const [segundo70, setSegundo70] = useState<number>(0);

    const [hora71, setHora71] = useState<number>(0);
    const [minuto71, setMinuto71] = useState<number>(0);
    const [segundo71, setSegundo71] = useState<number>(0);

    const [hora72, setHora72] = useState<number>(0);
    const [minuto72, setMinuto72] = useState<number>(0);
    const [segundo72, setSegundo72] = useState<number>(0);

    const [hora73, setHora73] = useState<number>(0);
    const [minuto73, setMinuto73] = useState<number>(0);
    const [segundo73, setSegundo73] = useState<number>(0);

    const [hora74, setHora74] = useState<number>(0);
    const [minuto74, setMinuto74] = useState<number>(0);
    const [segundo74, setSegundo74] = useState<number>(0);

    const [hora75, setHora75] = useState<number>(0);
    const [minuto75, setMinuto75] = useState<number>(0);
    const [segundo75, setSegundo75] = useState<number>(0);

    const [hora76, setHora76] = useState<number>(0);
    const [minuto76, setMinuto76] = useState<number>(0);
    const [segundo76, setSegundo76] = useState<number>(0);

    const [hora77, setHora77] = useState<number>(0);
    const [minuto77, setMinuto77] = useState<number>(0);
    const [segundo77, setSegundo77] = useState<number>(0);

    const [hora78, setHora78] = useState<number>(0);
    const [minuto78, setMinuto78] = useState<number>(0);
    const [segundo78, setSegundo78] = useState<number>(0);

    const [hora79, setHora79] = useState<number>(0);
    const [minuto79, setMinuto79] = useState<number>(0);
    const [segundo79, setSegundo79] = useState<number>(0);

    const [hora80, setHora80] = useState<number>(0);
    const [minuto80, setMinuto80] = useState<number>(0);
    const [segundo80, setSegundo80] = useState<number>(0);

    const [hora81, setHora81] = useState<number>(0);
    const [minuto81, setMinuto81] = useState<number>(0);
    const [segundo81, setSegundo81] = useState<number>(0);

    const [hora82, setHora82] = useState<number>(0);
    const [minuto82, setMinuto82] = useState<number>(0);
    const [segundo82, setSegundo82] = useState<number>(0);

    const [hora83, setHora83] = useState<number>(0);
    const [minuto83, setMinuto83] = useState<number>(0);
    const [segundo83, setSegundo83] = useState<number>(0);

    const [hora84, setHora84] = useState<number>(0);
    const [minuto84, setMinuto84] = useState<number>(0);
    const [segundo84, setSegundo84] = useState<number>(0);

    const [hora85, setHora85] = useState<number>(0);
    const [minuto85, setMinuto85] = useState<number>(0);
    const [segundo85, setSegundo85] = useState<number>(0);

    const [hora86, setHora86] = useState<number>(0);
    const [minuto86, setMinuto86] = useState<number>(0);
    const [segundo86, setSegundo86] = useState<number>(0);

    const [hora87, setHora87] = useState<number>(0);
    const [minuto87, setMinuto87] = useState<number>(0);
    const [segundo87, setSegundo87] = useState<number>(0);

    const [hora88, setHora88] = useState<number>(0);
    const [minuto88, setMinuto88] = useState<number>(0);
    const [segundo88, setSegundo88] = useState<number>(0);

    const [hora89, setHora89] = useState<number>(0);
    const [minuto89, setMinuto89] = useState<number>(0);
    const [segundo89, setSegundo89] = useState<number>(0);

    const [hora90, setHora90] = useState<number>(0);
    const [minuto90, setMinuto90] = useState<number>(0);
    const [segundo90, setSegundo90] = useState<number>(0);

    const [hora91, setHora91] = useState<number>(0);
    const [minuto91, setMinuto91] = useState<number>(0);
    const [segundo91, setSegundo91] = useState<number>(0);

    const [hora92, setHora92] = useState<number>(0);
    const [minuto92, setMinuto92] = useState<number>(0);
    const [segundo92, setSegundo92] = useState<number>(0);

    const [hora93, setHora93] = useState<number>(0);
    const [minuto93, setMinuto93] = useState<number>(0);
    const [segundo93, setSegundo93] = useState<number>(0);

    const [hora94, setHora94] = useState<number>(0);
    const [minuto94, setMinuto94] = useState<number>(0);
    const [segundo94, setSegundo94] = useState<number>(0);

    const [hora95, setHora95] = useState<number>(0);
    const [minuto95, setMinuto95] = useState<number>(0);
    const [segundo95, setSegundo95] = useState<number>(0);

    const [hora96, setHora96] = useState<number>(0);
    const [minuto96, setMinuto96] = useState<number>(0);
    const [segundo96, setSegundo96] = useState<number>(0);

    const [hora97, setHora97] = useState<number>(0);
    const [minuto97, setMinuto97] = useState<number>(0);
    const [segundo97, setSegundo97] = useState<number>(0);

    const [hora98, setHora98] = useState<number>(0);
    const [minuto98, setMinuto98] = useState<number>(0);
    const [segundo98, setSegundo98] = useState<number>(0);

    const [hora99, setHora99] = useState<number>(0);
    const [minuto99, setMinuto99] = useState<number>(0);
    const [segundo99, setSegundo99] = useState<number>(0);
    //#endregion

    const handleSorteioDraftCalouros = async () => {
        setSorteioRealizado(true);
        const dados: IDadosSorteio =
        {
            codigo_Liga: Number(codigoLiga),
            codigo_Temporada: codigoTemporada,
            codigo_Usuario: user.codUsuario
        };

        await DraftService.updateSorteio(dados)
            .then((result) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Sorteio realizado com sucesso!",
                    display: "none",
                    titulo: "Sucesso"
                });

                setRedirecionar("1");

            }).catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined){
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
    
                        logout();
                        setRedirecionar("0");
    
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
               
            });
    }

    const UseCountdown = (date: Date, sorteioFinalizado: boolean) => {
        const interval = setInterval(() => {
            let now = moment.tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss')
            const distance = moment(date).diff(now);
            const second = 1000;
            const minute = second * 60;
            const hour = minute * 60;
            const day = hour * 24;

            var hourNumber = Math.floor(distance / (1000 * 60 * 60));
            var minuteNumber = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var secondNumber = Math.floor((distance % (1000 * 60)) / 1000);

            if (hourNumber >= 0 && minuteNumber >= 0 && secondNumber >= 0) {
                //setDia(dayNumber);
                setHora1(hourNumber);
                setMinuto1(minuteNumber);
                setSegundo1(secondNumber);
            }

            if (distance < 0) {                                       
                setTempoZerado(true);
                clearInterval(interval);
            }
        }, 900);

        return (
            <Grid style={{ color: "red" }}>
                <span>{hora1.toString().padStart(2, "0")}</span>
                <span>:</span>
                <span>{minuto1.toString().padStart(2, "0")}</span>
                <span>:</span>
                <span>{segundo1.toString().padStart(2, "0")}</span>
            </Grid>
        )

    }

    const handleCalculartempo = (data: Date) => {
        let now = moment();
        let newDate = moment(data);
        // console.log("Testes")
        // console.log(new Date(data) <= new Date());
        // console.log(moment(data) <= moment());
        var ms = moment(newDate).diff(now.format());
        var d = moment.duration(ms);
        var h = Math.floor(d.asHours());

        if (h < 1) {
            return 1;
        }
        else if (h >= 1 && h < 6) {
            return 2;
        }
        else {
            return 3;
        }
    }
    //#endregion

    return (
        <LayoutBaseDePagina
            titulo={"Draft - " + nomeLiga}
            showLogoImg={showImagemDraft}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoNovo={false}
                    mostrarBotaoSalvar={false}
                    mostrarBotaoVoltar={true}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={2}>
                        <Grid  alignItems="center" justifyContent="center" width="100%">
                            <Paper>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={value} variant="scrollable"
                                        scrollButtons onChange={handleChangeTabs}>
                                        <Tab label="Draft Calouros" {...a11yProps(0)} onClick={handleEscondeDadosJogador} />
                                        <Tab label="Draft Inicial" {...a11yProps(1)} onClick={handleEscondeDadosJogador} />
                                        <Tab label="Salários" {...a11yProps(2)} />
                                        <Tab label="Sorteio Picks Calouro"
                                            //disabled={true}
                                            {...a11yProps(3)}
                                        />
                                    </Tabs>
                                </Box>
                                <TabPanel value={value} index={0}>
                                    {draftCalourosAberta || showCalourosEscolha ? (<Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                                        <Grid container direction="column" padding={2} spacing={2}
                                        >
                                            {isLoading && (<Grid size={{xs:12, sm:12}} >
                                                <LinearProgress variant="indeterminate" />
                                            </Grid>)}
                                            <Grid size={{xs:12, sm:12}} margin={1} >
                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>DRAFT CALOUROS</Typography>
                                                <hr />
                                            </Grid>
                                            <Box boxShadow={2} padding={1} width={"100%"} >
                                                <Grid container size={{xs:12, sm:12}} margin={1} spacing={1} display="flex" justifyItems="center"
                                                    style={{
                                                        backgroundImage: 'url(../../Draft2023Calouros2.png)',
                                                        backgroundRepeat: 'round',
                                                        width: '97%',
                                                        color: "#fbc02d !important",
                                                        maxHeight: "324px"
                                                    }}
                                                >
                                                    <Grid container size={{xs:12, sm:5}} display="flex" direction="row" padding={2}  >
                                                        <Grid size={{xs:2, sm:2}}  textAlign="right">
                                                            <Icon
                                                                sx={{
                                                                    color: "black !important",
                                                                    fontWeight: "bold",
                                                                    marginRight: 1,
                                                                    backgroundColor: "#fbc02d",
                                                                    padding: 1,
                                                                    borderRadius: "6px",
                                                                }}
                                                                style={{ fontSize: UtilidadeService.isMobile() ? 17 : 28 }}
                                                            >
                                                                query_builder
                                                            </Icon>
                                                        </Grid>
                                                        <Grid  size={{xs:10, sm:10}}>
                                                            <Typography sx={{
                                                                color: "black !important",
                                                                backgroundColor: "#fbc02d",
                                                                padding: "5px 10px",
                                                                borderRadius: "6px",
                                                                marginBottom: "5px"
                                                            }} variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 20, fontWeight: 600 }}>
                                                                {dataLimiteEscolhaCalouro}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container size={{xs:12, sm:7}} alignContent="end" direction={UtilidadeService.isMobile() ? "row" : "column"} sx={{ color: "rgba(255, 255, 255, 0.9) !important", display: "flex", paddingTop: "70px" }} >
                                                        <Grid  size={{xs:9, sm:9 }} padding={UtilidadeService.isMobile() ? 0 : 1} display="flex" justifyItems="flex-end" alignItems="end">
                                                            <Typography sx={{ color: "black !important", backgroundColor: "#fbc02d", padding: "5px 10px", borderRadius: "6px", marginBottom: "5px" }} variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 20, fontWeight: 600 }}>{nome_FranquiaCalouro !== null ? "FRANQUIA - " + nome_FranquiaCalouro : "FRANQUIA"}</Typography>
                                                        </Grid>
                                                        <Grid  size={{xs:3, sm:3}} padding={UtilidadeService.isMobile() ? 0 : 1} display="flex" justifyItems="flex-end" alignItems="end">
                                                            <img src={showImagemFranquiaCalouro} alt="SrcImagem" width={UtilidadeService.isMobile() ? 70 : 200} height={UtilidadeService.isMobile() ? 90 : 230} />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            {minhaVezEscolhaCalouros &&
                                                <>
                                                    <Grid  margin={UtilidadeService.isMobile() ? 0 : 1} padding={2}>
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>ESCOLHA DO JOGADOR</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid container spacing={1} display="flex" justifyItems="center" >
                                                        <Grid size={{xs:12, sm:6, md:3}} >
                                                            <Autocomplete
                                                                openText="Abrir"
                                                                closeText="Fechar"
                                                                noOptionsText="Sem opções"
                                                                loadingText="Carregando..."
                                                                disablePortal
                                                                options={opcoesAutoCompleteJogadorCalouros}
                                                                loading={isLoading}
                                                                disabled={isLoading}
                                                                value={autoCompleteSelectedOptionCalouros}
                                                                size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                                onChange={(event, newValue) => { setSelectedIdCompleteCalouros(newValue?.codigo); handleCarregarDadosJogadorCalouro(newValue?.codigo) }}
                                                                popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 20 : 28} /> : undefined}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Jogador"
                                                                        slotProps={{                                                                           
                                                                            inputLabel:{
                                                                              style: {
                                                                                fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                              }  
                                                                            }
                                                                          }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid  margin={1} paddingTop={2}>
                                                        {!removeLoading && <Loading />}
                                                    </Grid>
                                                    {existeDadosJogador && (
                                                        <>
                                                            <Grid  margin={UtilidadeService.isMobile() ? 0 : 1} padding={2} paddingBottom={0}>
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>DADOS JOGADOR</Typography>
                                                                <hr />
                                                            </Grid>
                                                            <Grid container margin={1} paddingBottom={0} display="flex" justifyItems="center" paddingTop={UtilidadeService.isMobile() ? 0 : 2} >
                                                                <Grid  size={{xs:3, sm:6, md:2}} display="flex" justifyItems="center" alignSelf="center">
                                                                    <Typography>
                                                                        <img src={fotoJogador}
                                                                            alt={nomeJogador} width={UtilidadeService.isMobile() ? 80 : 150} height={UtilidadeService.isMobile() ? 80 : 150}
                                                                            onError={({ currentTarget }) => {
                                                                                currentTarget.onerror = null;
                                                                                currentTarget.src = "../../../../semimagem.png";
                                                                                currentTarget.style.borderRadius = "50%";
                                                                                currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                                                                currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                                                                            }}
                                                                        />
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid container size={{xs:9, sm:6, md:6}} >
                                                                    <Grid size={{xs:12}}>
                                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 20, paddingLeft: 8 }}  ><span style={{ fontWeight: "bold" }}>JOGADOR:</span> {nomeJogador}</Typography>
                                                                    </Grid>
                                                                    <Grid size={{xs:12}} >
                                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 20, paddingLeft: 8 }}><span style={{ fontWeight: "bold" }}>FRANQUIA:</span> {franquiaJogador}</Typography>
                                                                    </Grid>
                                                                </Grid>
                                                                {minhaVezEscolhaCalouros && (
                                                                    <Grid size={{xs:12, sm:6, md:4}} display="flex" alignItems="center" justifyContent="center" justifyItems="center" textAlign="end">
                                                                        <Button
                                                                            color="primary"
                                                                            variant="contained"
                                                                            disableElevation
                                                                            onClick={handleEscolherJogadorCalouros}
                                                                            startIcon={<Icon>check</Icon>}
                                                                            disabled={isLoading}
                                                                        >
                                                                            Escolher
                                                                        </Button>
                                                                    </Grid>
                                                                )}
                                                            </Grid>
                                                            <Grid  margin={1} paddingTop={2}>
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>SALÁRIOS </Typography>
                                                                <hr />
                                                            </Grid>
                                                            <Grid container margin={1} spacing={1} display="flex" justifyItems="center" paddingTop={UtilidadeService.isMobile() ? 0 : 2} >
                                                                <Grid size={{xs:6, sm:6, md:2}} >
                                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{dadosHeader.ano1}</Typography>
                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario1Calouro)}</Typography>
                                                                </Grid>
                                                                <Grid size={{xs:6, sm:6, md:2}} >
                                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{dadosHeader.ano2}</Typography>
                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario2Calouro)}</Typography>
                                                                </Grid>
                                                                <Grid size={{xs:6, sm:6, md:2}} >
                                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{dadosHeader.ano3}</Typography>
                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario3Calouro)}</Typography>
                                                                </Grid>
                                                                <Grid size={{xs:6, sm:6, md:2}} >
                                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{dadosHeader.ano4}</Typography>
                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario4Calouro)}</Typography>
                                                                </Grid>
                                                                <Grid size={{xs:6, sm:6, md:2}} >
                                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{dadosHeader.ano5}</Typography>
                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>R$ {moedaRealLocaleValue(salario5Calouro)}</Typography>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid  margin={1}>
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>STATS</Typography>
                                                                <hr />
                                                            </Grid>
                                                            {UtilidadeService.isMobile() ?
                                                                (
                                                                    <Grid container size={{xs:12, sm:12}} padding={0}>
                                                                        <Box sx={{
                                                                            padding: 0,
                                                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                                            '& .super-app-theme--header': {
                                                                                backgroundColor: theme.palette.common.black,
                                                                                color: theme.palette.common.white
                                                                            },
                                                                            '& .super-app.negative': {
                                                                                color: 'red',
                                                                                fontWeight: 'bold'
                                                                            },
                                                                            '& .super-app.positive': {
                                                                                color: themeName === "light" ? "black" : "auto",
                                                                            },
                                                                        }}>
                                                                            <DataGrid
                                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                                autoHeight
                                                                                getRowId={(rows) => rows.codigo}
                                                                                columnVisibilityModel={{
                                                                                    minutos: listaDataGridCalouro.filter(f => f.minutos === undefined).length === 0,
                                                                                    arremessos: listaDataGridCalouro.filter(f => f.arremessos == undefined).length === 0,
                                                                                    lance_Livre: listaDataGridCalouro.filter(f => f.lance_Livre === undefined).length === 0,
                                                                                    tres_Pontos: listaDataGridCalouro.filter(f => f.tres_Pontos === undefined).length === 0,
                                                                                    pontos: listaDataGridCalouro.filter(f => f.pontos === undefined).length === 0,
                                                                                    rebotes: listaDataGridCalouro.filter(f => f.rebotes === undefined).length === 0,
                                                                                    rebotes_Ofensivos: listaDataGridCalouro.filter(f => f.rebotes_Ofensivos === undefined).length === 0,
                                                                                    rebotes_Defensivos: listaDataGridCalouro.filter(f => f.rebotes_Defensivos === undefined).length === 0,
                                                                                    assistencias: listaDataGridCalouro.filter(f => (f.assistencias === undefined)).length === 0,
                                                                                    steal: listaDataGridCalouro.filter(f => (f.steal === undefined)).length === 0,
                                                                                    bloqueios: listaDataGridCalouro.filter(f => (f.bloqueios === undefined)).length === 0,
                                                                                    turnovers: listaDataGridCalouro.filter(f => (f.turnovers === undefined)).length === 0,
                                                                                    faltas: listaDataGridCalouro.filter(f => (f.faltas === undefined)).length === 0,
                                                                                    min_Plus: listaDataGridCalouro.filter(f => (f.min_Plus === undefined)).length === 0,
                                                                                    porcentagem_Arremessos: listaDataGridCalouro.filter(f => (f.porcentagem_Arremessos === undefined)).length === 0,
                                                                                    porcentagem_Lance_Livre: listaDataGridCalouro.filter(f => (f.porcentagem_Lance_Livre === undefined)).length === 0,
                                                                                    porcentagem_Tres_Pontos: listaDataGridCalouro.filter(f => (f.porcentagem_Tres_Pontos === undefined)).length === 0,
                                                                                    peso_Total_Jogador: listaDataGridCalouro.filter(f => (f.peso_Total_Jogador === undefined)).length === 0,
                                                                                    arremessos_Errados: listaDataGridCalouro.filter(f => (f.arremessos_Errados === null)).length === 0,
                                                                                    lance_Livre_Errados: listaDataGridCalouro.filter(f => (f.lance_Livre_Errados === null)).length === 0,
                                                                                    tres_Pontos_Errados: listaDataGridCalouro.filter(f => (f.tres_Pontos_Errados === null)).length === 0,
                                                                                    stocks: listaDataGridCalouro.filter(f => f.stocks === null).length === 0,                                                                                    
                                                                                }
                                                                                }
                                                                                rows={listaDataGridCalouro}
                                                                                columns={columnsGeralCalouro}
                                                                                initialState={{
                                                                                    pagination: {
                                                                                        paginationModel: {
                                                                                            pageSize: 100,
                                                                                        },
                                                                                    },
                                                                                }}
                                                                                pageSizeOptions={[100]}
                                                                                //checkboxSelection
                                                                                disableRowSelectionOnClick
                                                                                disableColumnFilter
                                                                                disableColumnMenu
                                                                                hideFooter={true}
                                                                                sx={{
                                                                                    fontSize: 10,
                                                                                }}
                                                                            />
                                                                        </Box>
                                                                    </Grid>
                                                                ) :
                                                                (
                                                                    <Grid container margin={1} spacing={1} display="flex" justifyItems="center" paddingTop={2} >
                                                                        <Grid container size={{xs:12, sm:6, md:12}} paddingBottom={2} paddingTop={2} spacing={2}>
                                                                            {listaStats.length > 0 && (listaStats.map((m, i) => (
                                                                                <Grid key={i} size={{xs:12, sm:6, md:1}} >
                                                                                    <Typography key={`Typography1${i}`} variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>{m.nome}</Typography>
                                                                                    <Typography key={`Typography2${i}`} variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14 }}>{m.peso_Padrao}</Typography>
                                                                                </Grid>
                                                                            )))}
                                                                        </Grid>
                                                                    </Grid>
                                                                )}
                                                        </>
                                                    )}
                                                </>
                                            }
                                        </Grid>
                                        {escolhasCalourosRows.length > 0 && (
                                            <Grid container direction="column" padding={UtilidadeService.isMobile() ? 1 : 2} spacing={UtilidadeService.isMobile() ? 0 : 3} style={{ width: "100%" }}>
                                                <Grid container spacing={2} >
                                                    <Grid  size={{xs:12, sm:12}} >
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}> PICKS CALOUROS</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid  size={{xs:12, sm:12}} >
                                                        <Grid  margin={1} paddingBottom={1}>
                                                            {!removeLoading && <Loading />}
                                                        </Grid>
                                                        <Box sx={{
                                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                            '& .super-app-theme--header': {
                                                                backgroundColor: theme.palette.common.black,
                                                                color: theme.palette.common.white,
                                                            },
                                                            '& .super-app.negative': {
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .super-app.positive': {
                                                                color: themeName === "light" ? "black" : "auto",
                                                            },
                                                            '& .rowEscolha': {
                                                                backgroundColor: '#fbc02d',
                                                                color: "black"
                                                            },
                                                            '& .rowEscolha:hover': {
                                                                backgroundColor: '#fbc02d',
                                                                color: "black"
                                                            },
                                                            '& .MuiDataGrid-cell:focus': {
                                                                outline: 'none',
                                                            },

                                                            '& .MuiDataGrid-cell:focus-within': {
                                                                outline: 'none',
                                                            }
                                                        }}>
                                                            <DataGrid
                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                getRowId={(rowsEscolhas) => rowsEscolhas.escolha}
                                                                rows={escolhasCalourosRows}
                                                                columns={columnsEscolhas}
                                                                autoHeight
                                                                disableRowSelectionOnClick
                                                                getRowClassName={(params) => params.row.escolha_Atual === true ? `rowEscolha` : ''}
                                                                columnVisibilityModel={{
                                                                    escolha_Atual: false
                                                                }}
                                                                disableDensitySelector
                                                                disableVirtualization
                                                                disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                                disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                                hideFooterPagination={true}
                                                                hideFooter={true}
                                                                sx={{
                                                                    fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                }}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Box>
                                    )
                                        : <Grid  size={{xs:12, sm:12}} textAlign="initial" >
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Draft fechado!</Typography>
                                            <hr />
                                        </Grid>
                                    }
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    {draftInicialAberta ? (<Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                                        <Grid container size={{xs:12}} direction="column" padding={2} spacing={2}>
                                            {isLoading && (<Grid >
                                                <LinearProgress variant="indeterminate" />
                                            </Grid>)}
                                            <Grid container size={{xs:12}} margin={1} >
                                                <Grid size={{xs:12, sm:8, md:8}}>
                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                        DRAFT INICIAL ESCOLHAS
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{xs:12, sm:4, md:4}} display={dadosLiga?.salarios_Reais_NBA === true ? "flex" : "none"}
                                                    justifyContent="flex-end"
                                                >
                                                    <DonwloadSalarios nomeArquivo={`Salarios_temporada${codigoTemporada}`} />
                                                </Grid>
                                            </Grid>
                                            <Grid size={{xs:12}} margin={1} > <hr /></Grid>
                                            <Box boxShadow={2} padding={1} width={"100%"} >
                                                <Grid size={{xs:12}} container margin={1} spacing={1} display="flex" justifyItems="center"
                                                    style={{
                                                        backgroundImage: 'url(../../Draft_bg_2023.png)',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundSize: 'cover',
                                                        width: '97%',
                                                        color: "#fbc02d !important",
                                                        maxHeight: "324px"
                                                    }}
                                                >
                                                    <Grid container size={{xs:12, sm:5}} display="flex" direction="row" padding={2}>
                                                        <Grid size={{xs:2, sm:2}} textAlign="right">
                                                            <Icon
                                                                sx={{
                                                                    color: "black !important",
                                                                    fontWeight: "bold",
                                                                    marginRight: UtilidadeService.isMobile() ? 1 : "auto",
                                                                    backgroundColor: "#fbc02d",
                                                                    padding: 1,
                                                                    borderRadius: "6px"
                                                                }}
                                                                style={{ fontSize: UtilidadeService.isMobile() ? 18 : 28 }}
                                                            >
                                                                query_builder
                                                            </Icon>
                                                        </Grid>
                                                        <Grid  size={{xs:10, sm:10}} >
                                                            <Typography sx={{
                                                                color: "black !important",
                                                                backgroundColor: "#fbc02d",
                                                                padding: "5px 10px",
                                                                borderRadius: "6px",
                                                                marginBottom: "5px"
                                                            }} variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                {dataLimiteEscolhaInicial}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container size={{xs:12, sm:7}} direction={"row"} sx={{ color: "rgba(255, 255, 255, 0.9) !important", display: "flex", paddingTop: UtilidadeService.isMobile() ? 0 : "70px" }} >
                                                        <Grid size={{xs:12, sm:4}} paddingTop={UtilidadeService.isMobile() ? 0 : "15px"} paddingLeft={UtilidadeService.isMobile() ? 2 : "auto"} >
                                                            {showImagemFranquia !== "" && (<img src={showImagemFranquia} alt="SrcImagem" width={UtilidadeService.isMobile() ? "90" : "200"} height={UtilidadeService.isMobile() ? "100" : "230"} />)}
                                                        </Grid>
                                                        <Grid size={{xs:12, sm:8}} padding={UtilidadeService.isMobile() ? 1 : 2} display="flex" justifyContent={"end"} justifyItems="flex-end" alignItems="end">
                                                            <Typography style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "black !important", backgroundColor: "#fbc02d", padding: "5px 10px", borderRadius: "6px" }} variant="h6">{nome_Franquia !== null ? "FRANQUIA - " + nome_Franquia : "FRANQUIA"}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            {minhaVezEscolha && (
                                                <>
                                                    <Grid size={{xs:12}} margin={UtilidadeService.isMobile() ? 0 : 1} >
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>ESCOLHA DO JOGADOR</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid size={{xs:12}} container spacing={1} display="flex" justifyItems="center" >
                                                        <Grid size={{xs:10, sm:6, md:3}} >
                                                            <Autocomplete
                                                                openText="Abrir"
                                                                closeText="Fechar"
                                                                noOptionsText="Sem opções"
                                                                loadingText="Carregando..."
                                                                disablePortal
                                                                options={opcoesAutoCompleteJogadorInicial}
                                                                loading={isLoading}
                                                                disabled={isLoading}
                                                                value={autoCompleteSelectedOptionInicial}
                                                                size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                                onChange={(event, newValue) => { setSelectedIdCompleteInicial(newValue?.codigo); handleCarregarDadosJogadorInicial(newValue?.codigo); }}
                                                                popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 20 : 28} /> : undefined}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Jogador"
                                                                        slotProps={{                                                                           
                                                                            inputLabel:{
                                                                              style: {
                                                                                fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                              }  
                                                                            }
                                                                          }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid size={{xs:12}} >
                                                        {!removeLoading && <Loading />}
                                                    </Grid>
                                                    {existeDadosJogador && (
                                                        <>
                                                            <Grid size={{xs:12}}margin={UtilidadeService.isMobile() ? 0 : 1} padding={2} paddingBottom={0}>
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>DADOS JOGADOR</Typography>
                                                                <hr />
                                                            </Grid>
                                                            <Grid size={{xs:12}} container margin={1} spacing={1} paddingBottom={0} display="flex" justifyItems="center" paddingTop={UtilidadeService.isMobile() ? 0 : 2} >
                                                                <Grid  size={{xs:3, sm:6, md:2}} >
                                                                    <Typography> <img src={fotoJogador}
                                                                        alt="fotoJogador" width={UtilidadeService.isMobile() ? 80 : "180"} height={UtilidadeService.isMobile() ? 80 : "150"}
                                                                        onError={({ currentTarget }) => {
                                                                            currentTarget.onerror = null;
                                                                            currentTarget.src = "../../../../semimagem.png";
                                                                            currentTarget.style.borderRadius = "50%";
                                                                            currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                                                            currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                                                                        }
                                                                        }
                                                                    /></Typography>
                                                                </Grid>
                                                                <Grid  size={{xs:9, sm:6, md:6}} >
                                                                    <Typography padding={2} variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 20 }}><span style={{ fontWeight: "bold" }}>JOGADOR:</span> {nomeJogador}</Typography>
                                                                </Grid>
                                                                <Grid size={{xs:12, sm:6, md:3}} paddingRight={1} display="flex" alignItems={UtilidadeService.isMobile() ? "end" : "center"} justifyContent={UtilidadeService.isMobile() ? "end" : "center"} justifyItems={UtilidadeService.isMobile() ? "end" : "center"} textAlign="end">
                                                                    <Button
                                                                        color="primary"
                                                                        variant="contained"
                                                                        disableElevation
                                                                        onClick={handleEscolherJogadorInicial}
                                                                        startIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 20 : 28 }}>check</Icon>}
                                                                        disabled={isLoading || !showBotaoEscolherInicial}
                                                                        style={{ fontSize: UtilidadeService.isMobile() ? 13 : 20 }}
                                                                    >
                                                                        Escolher
                                                                    </Button>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid size={{xs:12}} padding={2} paddingBottom={0}>
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>SALÁRIOS </Typography>
                                                                <hr />
                                                            </Grid>
                                                            <Grid container size={{xs:12}} padding={UtilidadeService.isMobile() ? 0 : 2} margin={UtilidadeService.isMobile() ? 0 : 1} spacing={1} display="flex" justifyItems="center" paddingTop={2} >
                                                                <Grid  size={{xs:4, sm:6, md:2}} >
                                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 1</Typography>
                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>R$ {moedaRealLocaleValue(salario1)}</Typography>
                                                                </Grid>
                                                                <Grid  size={{xs:4, sm:6, md:2}} >
                                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 2</Typography>
                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>R$ {moedaRealLocaleValue(salario2)}</Typography>
                                                                </Grid>
                                                                <Grid  size={{xs:4, sm:6, md:2}} >
                                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 3</Typography>
                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>R$ {moedaRealLocaleValue(salario3)}</Typography>
                                                                </Grid>
                                                                <Grid  size={{xs:4, sm:6, md:2}} >
                                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 4</Typography>
                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>R$ {moedaRealLocaleValue(salario4)}</Typography>
                                                                </Grid>
                                                                <Grid  size={{xs:4, sm:6, md:2}} >
                                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Ano 5</Typography>
                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>R$ {moedaRealLocaleValue(salario5)}</Typography>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid size={{xs:12}} padding={2} paddingBottom={0}>
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>STATS</Typography>
                                                                <hr />
                                                            </Grid>
                                                            {UtilidadeService.isMobile() ?
                                                                (
                                                                    <Grid container size={{xs:12, sm:12}} padding={0}>
                                                                        <Box sx={{
                                                                            padding: 0,
                                                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                                            '& .super-app-theme--header': {
                                                                                backgroundColor: theme.palette.common.black,
                                                                                color: theme.palette.common.white
                                                                            },
                                                                            '& .super-app.negative': {
                                                                                color: 'red',
                                                                                fontWeight: 'bold'
                                                                            },
                                                                            '& .super-app.positive': {
                                                                                color: themeName === "light" ? "black" : "auto",
                                                                            },
                                                                        }}>
                                                                            <DataGrid
                                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                                autoHeight
                                                                                getRowId={(rows) => rows.codigo}
                                                                                columnVisibilityModel={{
                                                                                    minutos: lstDadosJogador.filter(f => f.minutos === null).length === 0,
                                                                                    arremessos: lstDadosJogador.filter(f => (f.arremessos === null)).length === 0,
                                                                                    lance_Livre: lstDadosJogador.filter(f => (f.lance_Livre === null)).length === 0,
                                                                                    tres_Pontos: lstDadosJogador.filter(f => (f.tres_Pontos === null)).length === 0,
                                                                                    pontos: lstDadosJogador.filter(f => f.pontos === null).length === 0,
                                                                                    rebotes: lstDadosJogador.filter(f => (f.rebotes === null)).length === 0,
                                                                                    rebotes_Ofensivos: lstDadosJogador.filter(f => (f.rebotes_Ofensivos === null)).length === 0,
                                                                                    rebotes_Defensivos: lstDadosJogador.filter(f => (f.rebotes_Defensivos === null)).length === 0,
                                                                                    assistencias: lstDadosJogador.filter(f => (f.assistencias === null)).length === 0,
                                                                                    steal: lstDadosJogador.filter(f => (f.steal === null)).length === 0,
                                                                                    bloqueios: lstDadosJogador.filter(f => (f.bloqueios === null)).length === 0,
                                                                                    turnovers: lstDadosJogador.filter(f => (f.turnovers === null)).length === 0,
                                                                                    faltas: lstDadosJogador.filter(f => (f.faltas === null)).length === 0,
                                                                                    min_Plus: lstDadosJogador.filter(f => (f.min_Plus === null)).length === 0,
                                                                                    porcentagem_Arremessos: lstDadosJogador.filter(f => (f.porcentagem_Arremessos === null)).length === 0,
                                                                                    porcentagem_Lance_Livre: lstDadosJogador.filter(f => (f.porcentagem_Lance_Livre === null)).length === 0,
                                                                                    porcentagem_Tres_Pontos: lstDadosJogador.filter(f => (f.porcentagem_Tres_Pontos === null)).length === 0,
                                                                                    peso_Total_Jogador: lstDadosJogador.filter(f => (f.peso_Total_Jogador === null)).length === 0,
                                                                                    arremessos_Errados: lstDadosJogador.filter(f => (f.arremessos_Errados === null)).length === 0,
                                                                                    lance_Livre_Errados: lstDadosJogador.filter(f => (f.lance_Livre_Errados === null)).length === 0,
                                                                                    tres_Pontos_Errados: lstDadosJogador.filter(f => (f.tres_Pontos_Errados === null)).length === 0,
                                                                                    stocks: lstDadosJogador.filter(f => f.stocks === null).length === 0,
                                                                                }
                                                                                }
                                                                                rows={lstDadosJogador}
                                                                                columns={columnsGeral}
                                                                                initialState={{
                                                                                    pagination: {
                                                                                        paginationModel: {
                                                                                            pageSize: 100,
                                                                                        },
                                                                                    },
                                                                                }}
                                                                                pageSizeOptions={[100]}
                                                                                //checkboxSelection
                                                                                disableRowSelectionOnClick
                                                                                disableColumnFilter
                                                                                disableColumnMenu
                                                                                hideFooter={true}
                                                                                sx={{
                                                                                    fontSize: 10,
                                                                                }}
                                                                            />
                                                                        </Box>
                                                                    </Grid>
                                                                ) :
                                                                (
                                                                    <Grid size={{xs:12}} container padding={2} margin={UtilidadeService.isMobile() ? 0 : 1} spacing={1} display="flex" justifyItems="center" paddingTop={2} >
                                                                        <Grid container size={{xs:12, sm:6, md:12}} paddingBottom={2} paddingTop={2} spacing={2}>
                                                                            {dadosJogador?.arremessos !== null && dadosJogador?.arremessos !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Arremessos" placement="top"><Typography variant="body1">FGM</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.arremessos.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.arremessos_Tentativas !== null && dadosJogador?.arremessos_Tentativas !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Arremessos Tentativas" placement="top"><Typography variant="body1">FGA</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.arremessos_Tentativas.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.lance_Livre !== null && dadosJogador?.lance_Livre !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Lance Livre" placement="top"><Typography variant="body1">FTM</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.lance_Livre.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.lance_Livre_Tentativas !== null && dadosJogador?.lance_Livre_Tentativas !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Lance Livre Tentativas" placement="top"><Typography variant="body1">FTA</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.lance_Livre_Tentativas.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.tres_Pontos !== null && dadosJogador?.tres_Pontos !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Três Pontos" placement="top"><Typography variant="body1">3PM</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.tres_Pontos.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.tres_Pontos_Tentativas !== null && dadosJogador?.tres_Pontos_Tentativas !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Três Pontos Tentativas" placement="top"><Typography variant="body1">3PA</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.tres_Pontos_Tentativas.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.pontos !== null && dadosJogador?.pontos !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Pontos" placement="top"><Typography variant="body1">PTS</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.pontos.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.rebotes !== null && dadosJogador?.rebotes !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Rebotes" placement="top"><Typography variant="body1">REB</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.rebotes.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.rebotes_Ofensivos !== null && dadosJogador?.rebotes_Ofensivos !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Rebotes" placement="top"><Typography variant="body1">OREB</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.rebotes_Ofensivos.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.rebotes_Defensivos !== null && dadosJogador?.rebotes_Defensivos !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Rebotes Defensivos" placement="top"><Typography variant="body1">DREB</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.rebotes_Defensivos.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.assistencias !== null && dadosJogador?.assistencias !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Assistências" placement="top"><Typography variant="body1">AST</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.assistencias.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.steal !== null && dadosJogador?.steal !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Roubo de Bola (steal)" placement="top"><Typography variant="body1">STL</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.steal.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.bloqueios !== null && dadosJogador?.bloqueios !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Bloqueios" placement="top"><Typography variant="body1">BLK</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.bloqueios.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.turnovers !== null && dadosJogador?.turnovers !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Turn Overs" placement="top"><Typography variant="body1">TO</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.turnovers.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.faltas !== null && dadosJogador?.faltas !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Faltas" placement="top"><Typography variant="body1">PF</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.faltas.toFixed(2).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.porcentagem_Arremessos !== null && dadosJogador?.porcentagem_Arremessos !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="% Arremessos" placement="top"><Typography variant="body1">FG%</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.porcentagem_Arremessos.toFixed(3).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.porcentagem_Lance_Livre !== null && dadosJogador?.porcentagem_Lance_Livre !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="% Lance Livre" placement="top"><Typography variant="body1">FT%</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.porcentagem_Lance_Livre.toFixed(3).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.porcentagem_Tres_Pontos !== null && dadosJogador?.porcentagem_Tres_Pontos !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="% Três Pontos" placement="top"><Typography variant="body1">3P%</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.porcentagem_Tres_Pontos.toFixed(3).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.min_Plus !== null && dadosJogador?.min_Plus !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Min Plus" placement="top"><Typography variant="body1">Min Plus</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.min_Plus.toFixed(0)}</Typography>
                                                                                </Grid>
                                                                            }
                                                                             {dadosJogador?.arremessos_Errados !== null && dadosJogador?.arremessos_Errados !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Arremessos Errados" placement="top"><Typography variant="body1">FGE</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.arremessos_Errados.toFixed(0)}</Typography>
                                                                                </Grid>
                                                                            }
                                                                             {dadosJogador?.lance_Livre_Errados !== null && dadosJogador?.lance_Livre_Errados !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Lance Livre Errados" placement="top"><Typography variant="body1">FTE</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.lance_Livre_Errados.toFixed(0)}</Typography>
                                                                                </Grid>
                                                                            }
                                                                             {dadosJogador?.tres_Pontos_Errados !== null && dadosJogador?.tres_Pontos_Errados !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Três Pontos Errados" placement="top"><Typography variant="body1">3PE</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.tres_Pontos_Errados.toFixed(0)}</Typography>
                                                                                </Grid>
                                                                            }
                                                                             {dadosJogador?.stocks !== null && dadosJogador?.stocks !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Stocks" placement="top"><Typography variant="body1">Stks</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.stocks.toFixed(0)}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.minutos !== null && dadosJogador?.minutos !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Minutos" placement="top"><Typography variant="body1">Min</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.minutos.toFixed(0)}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.quantidade_Jogos !== null && dadosJogador?.quantidade_Jogos !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Quantidade de Jogos" placement="top"><Typography variant="body1">Qtd. Jog.</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.quantidade_Jogos.toFixed(0).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            {dadosJogador?.peso_Total_Jogador !== null && dadosJogador?.peso_Total_Jogador !== undefined &&
                                                                                <Grid size={{xs:12, sm:4, md:1}} >
                                                                                    <Tooltip title="Total" placement="top"><Typography variant="body1">Total</Typography></Tooltip>
                                                                                    <Typography variant="body2" style={{ fontSize: UtilidadeService.isMobile() ? 11 : 14 }}>{dadosJogador?.peso_Total_Jogador.toFixed(3).toString().replace(".", ",")}</Typography>
                                                                                </Grid>
                                                                            }
                                                                            
                                                                        </Grid>
                                                                    </Grid>
                                                                )}
                                                        </>
                                                    )}
                                                </>)}
                                        </Grid>
                                        {escolhasInicialRows.length > 0 && (
                                            <Grid size={{xs:12}} container direction="column" padding={2}>
                                                <Grid size={{xs:12}} container >
                                                    <Grid  size={{xs:12, sm:12}} >
                                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>PICKS INICIAL</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid  size={{xs:12, sm:12}} >
                                                        <Grid  margin={1} paddingBottom={1}>
                                                            {!removeLoading && <Loading />}
                                                        </Grid>
                                                        <Box sx={{
                                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                            '& .super-app-theme--header': {
                                                                backgroundColor: theme.palette.common.black,
                                                                color: theme.palette.common.white,
                                                            },
                                                            '& .super-app.negative': {
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .super-app.positive': {
                                                                color: themeName === "light" ? "black" : "auto",
                                                            },
                                                            '& .rowEscolha': {
                                                                backgroundColor: '#fbc02d',
                                                                color: "black"
                                                            },
                                                            '& .rowEscolha:hover': {
                                                                backgroundColor: '#fbc02d',
                                                                color: "black"
                                                            },
                                                            '& .MuiDataGrid-cell:focus': {
                                                                outline: 'none',
                                                            },
                                                            '& .MuiDataGrid-cell:focus-within': {
                                                                outline: 'none',
                                                            }
                                                        }}>
                                                            <DataGrid
                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                getRowId={(rowsEscolhas) => rowsEscolhas.escolha}
                                                                rows={escolhasInicialRows}
                                                                columns={columnsEscolhas}
                                                                initialState={{
                                                                    pagination: {
                                                                        paginationModel: {
                                                                            pageSize: 15,
                                                                            page: paginaEscolha,
                                                                        },
                                                                    },
                                                                }}
                                                                autoHeight
                                                                pageSizeOptions={[15]}
                                                                disableVirtualization
                                                                disableRowSelectionOnClick
                                                                disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                                disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                                sx={{
                                                                    fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                }}
                                                                getRowClassName={(params) => params.row.escolha_Atual === true ? `rowEscolha` : ''}
                                                                columnVisibilityModel={{
                                                                    escolha_Atual: false
                                                                }}
                                                                hideFooterPagination={true}
                                                                hideFooter
                                                            />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Box>
                                    )
                                        : <Grid  size={{xs:12, sm:12}} textAlign="initial" >
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Draft inicial fechado!</Typography>
                                            <hr />
                                        </Grid>
                                    }
                                </TabPanel>
                                <TabPanel value={value} index={2}>
                                    <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                                        <Grid size={{xs:12}} container direction="column" padding={2} spacing={2}>
                                            <Grid  size={{xs:12, sm:12}} >
                                                <Typography variant="h6">Lista de Salários</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{xs:12, sm:12}} display="flex" justifyContent="initial" spacing={2}>
                                                <Grid  size={{xs:12, sm:6, md:3}} >
                                                    <FormControl fullWidth disabled={isLoading}>
                                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                                        <Select
                                                            variant="outlined"
                                                            native={false}
                                                            value={codigoTemporadaSalario}
                                                            label="Temporadas"
                                                            defaultValue={codigoTemporada}
                                                            onChange={(e) => setCodigoTemporadaSalario(Number(e.target.value))}
                                                        >
                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                            {
                                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }

                                                        </Select>
                                                    </FormControl >
                                                </Grid>
                                                <Grid  size={{xs:12, sm:6, md:3}} >
                                                    <FormControl fullWidth disabled={isLoading}>
                                                        <InputLabel id="demo-simple-select-label">Franquia Dono</InputLabel>
                                                        <Select
                                                            variant="outlined"
                                                            value={codigoFranquiaFiltro}
                                                            label="Franquia Dono"
                                                            onChange={(e) => setCodigoFranquiaFiltro(Number(e.target.value))}
                                                        >
                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                            {
                                                                lstFranquias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }

                                                        </Select>
                                                    </FormControl >
                                                </Grid>
                                                <Grid  size={{xs:12, sm:6, md:3}} >
                                                    <FormControl fullWidth disabled={isLoading}>
                                                        <InputLabel id="demo-simple-select-label">Rodada</InputLabel>
                                                        <Select
                                                            variant="outlined"
                                                            native={false}
                                                            value={codigoRodadaFiltro}
                                                            label="Rodada"
                                                            defaultValue={0}
                                                            onChange={(e) => setCodigoRodadaFiltro(Number(e.target.value))}
                                                        >
                                                            <MenuItem value={0}>Todos</MenuItem>
                                                            <MenuItem value={1}>1</MenuItem>
                                                            <MenuItem value={2}>2</MenuItem>


                                                        </Select>
                                                    </FormControl >
                                                </Grid>
                                                <Grid  size={{xs:6, sm:2, md:2}} display={"flex"} justifyContent={"end"} alignSelf={"center"}>
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={() => Pesquisar()}
                                                        startIcon={<Icon>change_circle</Icon>}
                                                    >
                                                        Pesquisar
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            {!removeLoading && <Loading />}
                                            {rowsSalario.length > 0 && (
                                                <>
                                                    <Grid  size={{xs:12, sm:12}} style={{ width: "100%" }}  >
                                                        <Box sx={{
                                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                            '& .super-app-theme--header': {
                                                                backgroundColor: theme.palette.common.black,
                                                                color: theme.palette.common.white,
                                                                fontWeight: "bold"

                                                            },
                                                            '& .super-app.negative': {
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .super-app.positive': {
                                                                color: themeName === "light" ? "black" : "auto",
                                                            },
                                                            '& .MuiDataGrid-columnHeaderTitle': {
                                                                fontWeight: "bold"
                                                            }
                                                        }}>
                                                            <DataGrid
                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                getRowId={(rows) => rows.codigo}
                                                                rows={rowsSalario}
                                                                columns={columnsSalarios}
                                                                initialState={{
                                                                    pagination: {
                                                                        paginationModel: {
                                                                            pageSize: 25,
                                                                            page: paginaSalarios - 1,
                                                                        },
                                                                    }
                                                                }}
                                                                autoHeight
                                                                pageSizeOptions={[25, 50, 100]}
                                                                disableRowSelectionOnClick
                                                                disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                                disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                                sx={{
                                                                    fontSize: UtilidadeService.isMobile() ? 10 : 13,
                                                                    fontWeight: 600
                                                                }}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid container size={{xs:12, sm:12}} sx={{ width: "100%" }}>
                                                        <Grid size={{xs:12}} container display="flex" direction="row" padding="10px" spacing={2}>
                                                            <Grid size={{xs:12, sm:6, md:3, lg:2, xl:2}} display="flex" alignSelf="center" >
                                                                <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: "white", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                                                                <Typography sx={{ padding: "2px", fontSize: "11px", fontWeight: "bold" }}>Normal </Typography>
                                                            </Grid>
                                                            <Grid size={{xs:12, sm:6, md:3, lg:2, xl:2}} display="flex" alignSelf="center">
                                                                <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: "#28a1db", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                                                                <Typography sx={{ padding: "2px", fontSize: "11px", fontWeight: "bold" }}>Player Option </Typography>
                                                            </Grid>
                                                            <Grid size={{xs:12, sm:6, md:3, lg:2, xl:2}} display="flex" alignSelf="center">
                                                                <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: "#d56413", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                                                                <Typography sx={{ padding: "2px", fontSize: "11px", fontWeight: "bold" }}>Team Option </Typography>
                                                            </Grid>
                                                            <Grid size={{xs:12, sm:6, md:3, lg:2, xl:2}} display="flex" alignSelf="center" >
                                                                <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: "#36ae2c", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                                                                <Typography sx={{ padding: "2px", fontSize: "11px", fontWeight: "bold" }}>Qualifying Offer </Typography>
                                                            </Grid>
                                                            <Grid size={{xs:12, sm:6, md:3, lg:2, xl:2}} display="flex" alignSelf="center">
                                                                <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: "#e51a8a", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                                                                <Typography sx={{ padding: "2px", fontSize: "11px", fontWeight: "bold" }}> Two-Way Contract</Typography>
                                                            </Grid>
                                                            <Grid size={{xs:12, sm:6, md:3, lg:2, xl:2}} display="flex" alignSelf="center">
                                                                <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: "red", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                                                                <Typography sx={{ padding: "2px", fontSize: "11px", fontWeight: "bold" }}> Contundido/Fora NBA </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>
                                    </Box>
                                </TabPanel>
                                <TabPanel value={value} index={3}>
                                    <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined" >
                                        <Grid size={{xs:12}} container direction="column" padding={2} spacing={2} >
                                            <Grid  size={{xs:12, sm:12}} >
                                                <Typography variant="h6">Sorteio de Picks Calouro</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{xs:12, sm:12}} display="flex" justifyContent="initial" spacing={2}>
                                                <Grid  size={{xs:12, sm:3,md:3}}>
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={handleSorteioDraftCalouros}
                                                        startIcon={<Icon>check</Icon>}
                                                        disabled={!comissario || sorteioRealizado}
                                                    >
                                                        Sortear Draft Calouros
                                                    </Button>
                                                </Grid>
                                                <Grid  size={{xs:12, sm:3,md:3}} >
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={(_) => CarregarDadosSorteioCalouros()}
                                                        startIcon={<Icon>cached</Icon>}
                                                        disabled={sorteioFinalizado}
                                                    >
                                                        RECARREGAR
                                                    </Button>
                                                </Grid>
                                                <Grid size={{xs:12, sm:5, md:6}} >
                                                    {!sorteioFinalizado && (
                                                        <>
                                                            <Typography variant="h6" style={{ fontSize: 18, display: "flex", justifyContent: "center" }} sx={{ color: "red" }}>
                                                                Duração (Hrs):
                                                            </Typography>
                                                            {UseCountdown(dataUltimoSorteio, sorteioRealizado)}
                                                        </>

                                                    )}
                                                </Grid>
                                                {sorteioRealizado || listaDataGridPorcentagemEscolha.length > 0 && (
                                                    <>
                                                        <Grid  size={{xs:12, sm:12}} paddingTop={5}>
                                                            <Typography variant="h6">Porcentagem Primeira Escolha</Typography>
                                                            <hr />
                                                        </Grid>
                                                        <Grid container size={{xs:12, sm:12}} padding={0}>
                                                            <Box sx={{
                                                                padding: 0,
                                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                },
                                                            }}>
                                                                <DataGrid
                                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                    autoHeight
                                                                    getRowId={(rows) => rows.codigo_Franquia_Original}
                                                                    rows={listaDataGridPorcentagemEscolha}
                                                                    columns={columnsGeralPorcentagem}
                                                                    initialState={{
                                                                        pagination: {
                                                                            paginationModel: {
                                                                                pageSize: 100,
                                                                            },
                                                                        },
                                                                    }}
                                                                    columnVisibilityModel={{
                                                                        codigo_Franquia_Original: false
                                                                    }}
                                                                    pageSizeOptions={[100]}
                                                                    //checkboxSelection
                                                                    disableRowSelectionOnClick
                                                                    disableColumnFilter
                                                                    disableColumnMenu
                                                                    hideFooter={true}
                                                                // sx={{
                                                                //     fontSize: 10,
                                                                // }}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    </>
                                                )}
                                            </Grid>
                                            {!removeLoading && <Loading />}
                                            {rowsSorteioPicks.length > 0 &&
                                                <>
                                                    <Grid container size={{xs:12, sm:12}} textAlign="initial" >
                                                        <Grid size={{xs:12}}paddingTop={4}>
                                                            <Typography variant="h6">FRANQUIAS POR POSIÇÃO</Typography>
                                                        </Grid>
                                                        <Grid size={{xs:12}}>
                                                            <hr />
                                                        </Grid>
                                                    </Grid>
                                                    <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined" width={"100%"}>
                                                        <Grid size={{xs:12}} container direction="column" padding={2} spacing={3} marginLeft={"-16px"} marginTop={"-16px"}>
                                                            <Grid size={{xs:12}} container spacing={2} >
                                                                {rowsSorteioPicks.length > 0 && rowsSorteioPicks.map((r, i) => (
                                                                    <Card key={`Card${i}`} sx={{ border: "2px solid", borderColor: "#303134", m: UtilidadeService.isMobile() ? 0 : 1, width: UtilidadeService.isMobile() ? "48%" : "18%" }}>
                                                                        <CardContent sx={{ paddingBottom: 1, backgroundColor: "#252525", height: UtilidadeService.isMobile() ? "160px" : "175px" }} >
                                                                            <Grid container size={{xs:12, sm:12, md:12}} direction={"column"} display="flex" justifyContent="center" textAlign="center" paddingBottom={1}>
                                                                                <Grid size={{xs:12}}>
                                                                                    <Typography variant="body1">
                                                                                        Posição: {r.posicao_Final}
                                                                                    </Typography>
                                                                                </Grid>
                                                                                <Grid size={{xs:12}}padding={"8px"}>
                                                                                    <img src={r.logo_Franquia_Original === null ? showImagemFranquia : r.logo_Franquia_Original} alt="SrcImagem" width={UtilidadeService.isMobile() ? "70" : "100"} height={UtilidadeService.isMobile() ? "80" : "110"} />
                                                                                </Grid>
                                                                                <Grid size={{xs:12}}>
                                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>
                                                                                        {r.nome_Franquia_Original}
                                                                                    </Typography>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </CardContent>
                                                                    </Card>
                                                                ))}
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </>
                                            }
                                        </Grid>
                                    </Box>
                                </TabPanel>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    )
}



